
(function(l, r) { if (!l || l.getElementById('livereloadscript')) return; r = l.createElement('script'); r.async = 1; r.src = '//' + (self.location.host || 'localhost').split(':')[0] + ':35729/livereload.js?snipver=1'; r.id = 'livereloadscript'; l.getElementsByTagName('head')[0].appendChild(r) })(self.document);
(function () {
    'use strict';

    function noop() { }
    function assign(tar, src) {
        // @ts-ignore
        for (const k in src)
            tar[k] = src[k];
        return tar;
    }
    // Adapted from https://github.com/then/is-promise/blob/master/index.js
    // Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
    function is_promise(value) {
        return !!value && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
    }
    function run(fn) {
        return fn();
    }
    function blank_object() {
        return Object.create(null);
    }
    function run_all(fns) {
        fns.forEach(run);
    }
    function is_function(thing) {
        return typeof thing === 'function';
    }
    function safe_not_equal(a, b) {
        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
    }
    let src_url_equal_anchor;
    function src_url_equal(element_src, url) {
        if (!src_url_equal_anchor) {
            src_url_equal_anchor = document.createElement('a');
        }
        src_url_equal_anchor.href = url;
        return element_src === src_url_equal_anchor.href;
    }
    function is_empty(obj) {
        return Object.keys(obj).length === 0;
    }
    function subscribe(store, ...callbacks) {
        if (store == null) {
            return noop;
        }
        const unsub = store.subscribe(...callbacks);
        return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
    }
    function get_store_value(store) {
        let value;
        subscribe(store, _ => value = _)();
        return value;
    }
    function component_subscribe(component, store, callback) {
        component.$$.on_destroy.push(subscribe(store, callback));
    }
    function create_slot(definition, ctx, $$scope, fn) {
        if (definition) {
            const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
            return definition[0](slot_ctx);
        }
    }
    function get_slot_context(definition, ctx, $$scope, fn) {
        return definition[1] && fn
            ? assign($$scope.ctx.slice(), definition[1](fn(ctx)))
            : $$scope.ctx;
    }
    function get_slot_changes(definition, $$scope, dirty, fn) {
        if (definition[2] && fn) {
            const lets = definition[2](fn(dirty));
            if ($$scope.dirty === undefined) {
                return lets;
            }
            if (typeof lets === 'object') {
                const merged = [];
                const len = Math.max($$scope.dirty.length, lets.length);
                for (let i = 0; i < len; i += 1) {
                    merged[i] = $$scope.dirty[i] | lets[i];
                }
                return merged;
            }
            return $$scope.dirty | lets;
        }
        return $$scope.dirty;
    }
    function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
        if (slot_changes) {
            const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
            slot.p(slot_context, slot_changes);
        }
    }
    function get_all_dirty_from_scope($$scope) {
        if ($$scope.ctx.length > 32) {
            const dirty = [];
            const length = $$scope.ctx.length / 32;
            for (let i = 0; i < length; i++) {
                dirty[i] = -1;
            }
            return dirty;
        }
        return -1;
    }
    function exclude_internal_props(props) {
        const result = {};
        for (const k in props)
            if (k[0] !== '$')
                result[k] = props[k];
        return result;
    }
    function set_store_value(store, ret, value) {
        store.set(value);
        return ret;
    }
    function append(target, node) {
        target.appendChild(node);
    }
    function append_styles(target, style_sheet_id, styles) {
        const append_styles_to = get_root_for_style(target);
        if (!append_styles_to.getElementById(style_sheet_id)) {
            const style = element('style');
            style.id = style_sheet_id;
            style.textContent = styles;
            append_stylesheet(append_styles_to, style);
        }
    }
    function get_root_for_style(node) {
        if (!node)
            return document;
        const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
        if (root && root.host) {
            return root;
        }
        return node.ownerDocument;
    }
    function append_stylesheet(node, style) {
        append(node.head || node, style);
        return style.sheet;
    }
    function insert(target, node, anchor) {
        target.insertBefore(node, anchor || null);
    }
    function detach(node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
    function destroy_each(iterations, detaching) {
        for (let i = 0; i < iterations.length; i += 1) {
            if (iterations[i])
                iterations[i].d(detaching);
        }
    }
    function element(name) {
        return document.createElement(name);
    }
    function text(data) {
        return document.createTextNode(data);
    }
    function space() {
        return text(' ');
    }
    function empty() {
        return text('');
    }
    function listen(node, event, handler, options) {
        node.addEventListener(event, handler, options);
        return () => node.removeEventListener(event, handler, options);
    }
    function prevent_default(fn) {
        return function (event) {
            event.preventDefault();
            // @ts-ignore
            return fn.call(this, event);
        };
    }
    function attr(node, attribute, value) {
        if (value == null)
            node.removeAttribute(attribute);
        else if (node.getAttribute(attribute) !== value)
            node.setAttribute(attribute, value);
    }
    /**
     * List of attributes that should always be set through the attr method,
     * because updating them through the property setter doesn't work reliably.
     * In the example of `width`/`height`, the problem is that the setter only
     * accepts numeric values, but the attribute can also be set to a string like `50%`.
     * If this list becomes too big, rethink this approach.
     */
    const always_set_through_set_attribute = ['width', 'height'];
    function set_attributes(node, attributes) {
        // @ts-ignore
        const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
        for (const key in attributes) {
            if (attributes[key] == null) {
                node.removeAttribute(key);
            }
            else if (key === 'style') {
                node.style.cssText = attributes[key];
            }
            else if (key === '__value') {
                node.value = node[key] = attributes[key];
            }
            else if (descriptors[key] && descriptors[key].set && always_set_through_set_attribute.indexOf(key) === -1) {
                node[key] = attributes[key];
            }
            else {
                attr(node, key, attributes[key]);
            }
        }
    }
    function children(element) {
        return Array.from(element.childNodes);
    }
    function set_data(text, data) {
        data = '' + data;
        if (text.data === data)
            return;
        text.data = data;
    }
    function set_input_value(input, value) {
        input.value = value == null ? '' : value;
    }
    function set_style(node, key, value, important) {
        if (value == null) {
            node.style.removeProperty(key);
        }
        else {
            node.style.setProperty(key, value, important ? 'important' : '');
        }
    }
    function select_option(select, value, mounting) {
        for (let i = 0; i < select.options.length; i += 1) {
            const option = select.options[i];
            if (option.__value === value) {
                option.selected = true;
                return;
            }
        }
        if (!mounting || value !== undefined) {
            select.selectedIndex = -1; // no option should be selected
        }
    }
    function select_value(select) {
        const selected_option = select.querySelector(':checked');
        return selected_option && selected_option.__value;
    }
    function toggle_class(element, name, toggle) {
        element.classList[toggle ? 'add' : 'remove'](name);
    }

    let current_component;
    function set_current_component(component) {
        current_component = component;
    }
    function get_current_component() {
        if (!current_component)
            throw new Error('Function called outside component initialization');
        return current_component;
    }
    /**
     * Associates an arbitrary `context` object with the current component and the specified `key`
     * and returns that object. The context is then available to children of the component
     * (including slotted content) with `getContext`.
     *
     * Like lifecycle functions, this must be called during component initialisation.
     *
     * https://svelte.dev/docs#run-time-svelte-setcontext
     */
    function setContext(key, context) {
        get_current_component().$$.context.set(key, context);
        return context;
    }
    /**
     * Retrieves the context that belongs to the closest parent component with the specified `key`.
     * Must be called during component initialisation.
     *
     * https://svelte.dev/docs#run-time-svelte-getcontext
     */
    function getContext(key) {
        return get_current_component().$$.context.get(key);
    }

    const dirty_components = [];
    const binding_callbacks = [];
    let render_callbacks = [];
    const flush_callbacks = [];
    const resolved_promise = /* @__PURE__ */ Promise.resolve();
    let update_scheduled = false;
    function schedule_update() {
        if (!update_scheduled) {
            update_scheduled = true;
            resolved_promise.then(flush);
        }
    }
    function add_render_callback(fn) {
        render_callbacks.push(fn);
    }
    function add_flush_callback(fn) {
        flush_callbacks.push(fn);
    }
    // flush() calls callbacks in this order:
    // 1. All beforeUpdate callbacks, in order: parents before children
    // 2. All bind:this callbacks, in reverse order: children before parents.
    // 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
    //    for afterUpdates called during the initial onMount, which are called in
    //    reverse order: children before parents.
    // Since callbacks might update component values, which could trigger another
    // call to flush(), the following steps guard against this:
    // 1. During beforeUpdate, any updated components will be added to the
    //    dirty_components array and will cause a reentrant call to flush(). Because
    //    the flush index is kept outside the function, the reentrant call will pick
    //    up where the earlier call left off and go through all dirty components. The
    //    current_component value is saved and restored so that the reentrant call will
    //    not interfere with the "parent" flush() call.
    // 2. bind:this callbacks cannot trigger new flush() calls.
    // 3. During afterUpdate, any updated components will NOT have their afterUpdate
    //    callback called a second time; the seen_callbacks set, outside the flush()
    //    function, guarantees this behavior.
    const seen_callbacks = new Set();
    let flushidx = 0; // Do *not* move this inside the flush() function
    function flush() {
        // Do not reenter flush while dirty components are updated, as this can
        // result in an infinite loop. Instead, let the inner flush handle it.
        // Reentrancy is ok afterwards for bindings etc.
        if (flushidx !== 0) {
            return;
        }
        const saved_component = current_component;
        do {
            // first, call beforeUpdate functions
            // and update components
            try {
                while (flushidx < dirty_components.length) {
                    const component = dirty_components[flushidx];
                    flushidx++;
                    set_current_component(component);
                    update(component.$$);
                }
            }
            catch (e) {
                // reset dirty state to not end up in a deadlocked state and then rethrow
                dirty_components.length = 0;
                flushidx = 0;
                throw e;
            }
            set_current_component(null);
            dirty_components.length = 0;
            flushidx = 0;
            while (binding_callbacks.length)
                binding_callbacks.pop()();
            // then, once components are updated, call
            // afterUpdate functions. This may cause
            // subsequent updates...
            for (let i = 0; i < render_callbacks.length; i += 1) {
                const callback = render_callbacks[i];
                if (!seen_callbacks.has(callback)) {
                    // ...so guard against infinite loops
                    seen_callbacks.add(callback);
                    callback();
                }
            }
            render_callbacks.length = 0;
        } while (dirty_components.length);
        while (flush_callbacks.length) {
            flush_callbacks.pop()();
        }
        update_scheduled = false;
        seen_callbacks.clear();
        set_current_component(saved_component);
    }
    function update($$) {
        if ($$.fragment !== null) {
            $$.update();
            run_all($$.before_update);
            const dirty = $$.dirty;
            $$.dirty = [-1];
            $$.fragment && $$.fragment.p($$.ctx, dirty);
            $$.after_update.forEach(add_render_callback);
        }
    }
    /**
     * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
     */
    function flush_render_callbacks(fns) {
        const filtered = [];
        const targets = [];
        render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
        targets.forEach((c) => c());
        render_callbacks = filtered;
    }
    const outroing = new Set();
    let outros;
    function group_outros() {
        outros = {
            r: 0,
            c: [],
            p: outros // parent group
        };
    }
    function check_outros() {
        if (!outros.r) {
            run_all(outros.c);
        }
        outros = outros.p;
    }
    function transition_in(block, local) {
        if (block && block.i) {
            outroing.delete(block);
            block.i(local);
        }
    }
    function transition_out(block, local, detach, callback) {
        if (block && block.o) {
            if (outroing.has(block))
                return;
            outroing.add(block);
            outros.c.push(() => {
                outroing.delete(block);
                if (callback) {
                    if (detach)
                        block.d(1);
                    callback();
                }
            });
            block.o(local);
        }
        else if (callback) {
            callback();
        }
    }

    function handle_promise(promise, info) {
        const token = info.token = {};
        function update(type, index, key, value) {
            if (info.token !== token)
                return;
            info.resolved = value;
            let child_ctx = info.ctx;
            if (key !== undefined) {
                child_ctx = child_ctx.slice();
                child_ctx[key] = value;
            }
            const block = type && (info.current = type)(child_ctx);
            let needs_flush = false;
            if (info.block) {
                if (info.blocks) {
                    info.blocks.forEach((block, i) => {
                        if (i !== index && block) {
                            group_outros();
                            transition_out(block, 1, 1, () => {
                                if (info.blocks[i] === block) {
                                    info.blocks[i] = null;
                                }
                            });
                            check_outros();
                        }
                    });
                }
                else {
                    info.block.d(1);
                }
                block.c();
                transition_in(block, 1);
                block.m(info.mount(), info.anchor);
                needs_flush = true;
            }
            info.block = block;
            if (info.blocks)
                info.blocks[index] = block;
            if (needs_flush) {
                flush();
            }
        }
        if (is_promise(promise)) {
            const current_component = get_current_component();
            promise.then(value => {
                set_current_component(current_component);
                update(info.then, 1, info.value, value);
                set_current_component(null);
            }, error => {
                set_current_component(current_component);
                update(info.catch, 2, info.error, error);
                set_current_component(null);
                if (!info.hasCatch) {
                    throw error;
                }
            });
            // if we previously had a then/catch block, destroy it
            if (info.current !== info.pending) {
                update(info.pending, 0);
                return true;
            }
        }
        else {
            if (info.current !== info.then) {
                update(info.then, 1, info.value, promise);
                return true;
            }
            info.resolved = promise;
        }
    }
    function update_await_block_branch(info, ctx, dirty) {
        const child_ctx = ctx.slice();
        const { resolved } = info;
        if (info.current === info.then) {
            child_ctx[info.value] = resolved;
        }
        if (info.current === info.catch) {
            child_ctx[info.error] = resolved;
        }
        info.block.p(child_ctx, dirty);
    }

    function get_spread_update(levels, updates) {
        const update = {};
        const to_null_out = {};
        const accounted_for = { $$scope: 1 };
        let i = levels.length;
        while (i--) {
            const o = levels[i];
            const n = updates[i];
            if (n) {
                for (const key in o) {
                    if (!(key in n))
                        to_null_out[key] = 1;
                }
                for (const key in n) {
                    if (!accounted_for[key]) {
                        update[key] = n[key];
                        accounted_for[key] = 1;
                    }
                }
                levels[i] = n;
            }
            else {
                for (const key in o) {
                    accounted_for[key] = 1;
                }
            }
        }
        for (const key in to_null_out) {
            if (!(key in update))
                update[key] = undefined;
        }
        return update;
    }

    function bind(component, name, callback) {
        const index = component.$$.props[name];
        if (index !== undefined) {
            component.$$.bound[index] = callback;
            callback(component.$$.ctx[index]);
        }
    }
    function create_component(block) {
        block && block.c();
    }
    function mount_component(component, target, anchor, customElement) {
        const { fragment, after_update } = component.$$;
        fragment && fragment.m(target, anchor);
        if (!customElement) {
            // onMount happens before the initial afterUpdate
            add_render_callback(() => {
                const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
                // if the component was destroyed immediately
                // it will update the `$$.on_destroy` reference to `null`.
                // the destructured on_destroy may still reference to the old array
                if (component.$$.on_destroy) {
                    component.$$.on_destroy.push(...new_on_destroy);
                }
                else {
                    // Edge case - component was destroyed immediately,
                    // most likely as a result of a binding initialising
                    run_all(new_on_destroy);
                }
                component.$$.on_mount = [];
            });
        }
        after_update.forEach(add_render_callback);
    }
    function destroy_component(component, detaching) {
        const $$ = component.$$;
        if ($$.fragment !== null) {
            flush_render_callbacks($$.after_update);
            run_all($$.on_destroy);
            $$.fragment && $$.fragment.d(detaching);
            // TODO null out other refs, including component.$$ (but need to
            // preserve final state?)
            $$.on_destroy = $$.fragment = null;
            $$.ctx = [];
        }
    }
    function make_dirty(component, i) {
        if (component.$$.dirty[0] === -1) {
            dirty_components.push(component);
            schedule_update();
            component.$$.dirty.fill(0);
        }
        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
    }
    function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
        const parent_component = current_component;
        set_current_component(component);
        const $$ = component.$$ = {
            fragment: null,
            ctx: [],
            // state
            props,
            update: noop,
            not_equal,
            bound: blank_object(),
            // lifecycle
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
            // everything else
            callbacks: blank_object(),
            dirty,
            skip_bound: false,
            root: options.target || parent_component.$$.root
        };
        append_styles && append_styles($$.root);
        let ready = false;
        $$.ctx = instance
            ? instance(component, options.props || {}, (i, ret, ...rest) => {
                const value = rest.length ? rest[0] : ret;
                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                    if (!$$.skip_bound && $$.bound[i])
                        $$.bound[i](value);
                    if (ready)
                        make_dirty(component, i);
                }
                return ret;
            })
            : [];
        $$.update();
        ready = true;
        run_all($$.before_update);
        // `false` as a special case of no DOM component
        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
        if (options.target) {
            if (options.hydrate) {
                const nodes = children(options.target);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.l(nodes);
                nodes.forEach(detach);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.c();
            }
            if (options.intro)
                transition_in(component.$$.fragment);
            mount_component(component, options.target, options.anchor, options.customElement);
            flush();
        }
        set_current_component(parent_component);
    }
    /**
     * Base class for Svelte components. Used when dev=false.
     */
    class SvelteComponent {
        $destroy() {
            destroy_component(this, 1);
            this.$destroy = noop;
        }
        $on(type, callback) {
            if (!is_function(callback)) {
                return noop;
            }
            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
            callbacks.push(callback);
            return () => {
                const index = callbacks.indexOf(callback);
                if (index !== -1)
                    callbacks.splice(index, 1);
            };
        }
        $set($$props) {
            if (this.$$set && !is_empty($$props)) {
                this.$$.skip_bound = true;
                this.$$set($$props);
                this.$$.skip_bound = false;
            }
        }
    }

    const subscriber_queue = [];
    /**
     * Create a `Writable` store that allows both updating and reading by subscription.
     * @param {*=}value initial value
     * @param {StartStopNotifier=} start
     */
    function writable(value, start = noop) {
        let stop;
        const subscribers = new Set();
        function set(new_value) {
            if (safe_not_equal(value, new_value)) {
                value = new_value;
                if (stop) { // store is ready
                    const run_queue = !subscriber_queue.length;
                    for (const subscriber of subscribers) {
                        subscriber[1]();
                        subscriber_queue.push(subscriber, value);
                    }
                    if (run_queue) {
                        for (let i = 0; i < subscriber_queue.length; i += 2) {
                            subscriber_queue[i][0](subscriber_queue[i + 1]);
                        }
                        subscriber_queue.length = 0;
                    }
                }
            }
        }
        function update(fn) {
            set(fn(value));
        }
        function subscribe(run, invalidate = noop) {
            const subscriber = [run, invalidate];
            subscribers.add(subscriber);
            if (subscribers.size === 1) {
                stop = start(set) || noop;
            }
            run(value);
            return () => {
                subscribers.delete(subscriber);
                if (subscribers.size === 0 && stop) {
                    stop();
                    stop = null;
                }
            };
        }
        return { set, update, subscribe };
    }

    var Page;
    (function (Page) {
        Page[Page["Cart"] = 0] = "Cart";
        Page[Page["Filters"] = 1] = "Filters";
        Page[Page["Form"] = 2] = "Form";
        Page[Page["ThankYou"] = 3] = "ThankYou";
    })(Page || (Page = {}));

    const _isOpen = writable(false);
    const _isLoading = writable(false);
    const _formUrl = writable();
    const _thankYouText = writable();
    const _thankYouImage = writable();
    const _variants = writable([]);
    const _filteredVariants = writable([]);
    const _selectedVariants = writable([]);
    const _currentPage = writable(Page.Cart);
    const _colorFilters = writable({});
    const _featureFilters = writable({});
    const _typeFilters = writable({});
    const _patternFilters = writable({});
    const _selectedFilters = writable({});

    /* src/components/NavButton.svelte generated by Svelte v3.59.2 */

    function add_css$i(target) {
    	append_styles(target, "svelte-1qc51j5", ".NavButton.svelte-1qc51j5{display:block;position:relative;padding:12px 15px;font-size:14px;font-weight:600;letter-spacing:1px;text-transform:uppercase;text-decoration:none}.NavButton.svelte-1qc51j5:after{content:\"\";position:absolute;top:50%;right:0;width:8px;height:8px;border-style:solid;border-width:0 0 1px 1px;border-color:var(--color-body-text);transform:rotate(225deg) translateY(-50%);transform-origin:top}.NavButton.secondary.svelte-1qc51j5:after{left:0;transform:rotate(45deg) translateY(-50%);margin-top:0}");
    }

    function create_fragment$j(ctx) {
    	let button;
    	let current;
    	let mounted;
    	let dispose;
    	const default_slot_template = /*#slots*/ ctx[4].default;
    	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[3], null);

    	return {
    		c() {
    			button = element("button");
    			if (default_slot) default_slot.c();
    			attr(button, "class", "NavButton svelte-1qc51j5");
    			button.disabled = /*disabled*/ ctx[1];
    			toggle_class(button, "secondary", /*secondary*/ ctx[2]);
    		},
    		m(target, anchor) {
    			insert(target, button, anchor);

    			if (default_slot) {
    				default_slot.m(button, null);
    			}

    			current = true;

    			if (!mounted) {
    				dispose = listen(button, "click", function () {
    					if (is_function(/*onClick*/ ctx[0])) /*onClick*/ ctx[0].apply(this, arguments);
    				});

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;

    			if (default_slot) {
    				if (default_slot.p && (!current || dirty & /*$$scope*/ 8)) {
    					update_slot_base(
    						default_slot,
    						default_slot_template,
    						ctx,
    						/*$$scope*/ ctx[3],
    						!current
    						? get_all_dirty_from_scope(/*$$scope*/ ctx[3])
    						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[3], dirty, null),
    						null
    					);
    				}
    			}

    			if (!current || dirty & /*disabled*/ 2) {
    				button.disabled = /*disabled*/ ctx[1];
    			}

    			if (!current || dirty & /*secondary*/ 4) {
    				toggle_class(button, "secondary", /*secondary*/ ctx[2]);
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(default_slot, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(default_slot, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(button);
    			if (default_slot) default_slot.d(detaching);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$i($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	let { onClick } = $$props;
    	let { disabled = false } = $$props;
    	let { secondary = false } = $$props;

    	$$self.$$set = $$props => {
    		if ('onClick' in $$props) $$invalidate(0, onClick = $$props.onClick);
    		if ('disabled' in $$props) $$invalidate(1, disabled = $$props.disabled);
    		if ('secondary' in $$props) $$invalidate(2, secondary = $$props.secondary);
    		if ('$$scope' in $$props) $$invalidate(3, $$scope = $$props.$$scope);
    	};

    	return [onClick, disabled, secondary, $$scope, slots];
    }

    class NavButton extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$i, create_fragment$j, safe_not_equal, { onClick: 0, disabled: 1, secondary: 2 }, add_css$i);
    	}
    }

    function navTo(page) {
        _currentPage.update(() => page);
    }

    /* src/components/FiltersHeader.svelte generated by Svelte v3.59.2 */

    function add_css$h(target) {
    	append_styles(target, "svelte-1a9tewu", ".FiltersHeader.svelte-1a9tewu{display:flex;justify-content:space-between;background:#fff;padding:0 20px}.FiltersHeader__body.svelte-1a9tewu{padding:16px 20px 16px 0}.FiltersHeader__options.svelte-1a9tewu{font-size:14px}");
    }

    // (16:4) <NavButton onClick={handleFilter}>
    function create_default_slot$4(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("Filter Fabrics");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    function create_fragment$i(ctx) {
    	let div1;
    	let div0;
    	let span;
    	let t0_value = /*$_filteredVariants*/ ctx[0].length + "";
    	let t0;
    	let t1;
    	let t2;
    	let navbutton;
    	let current;

    	navbutton = new NavButton({
    			props: {
    				onClick: /*handleFilter*/ ctx[1],
    				$$slots: { default: [create_default_slot$4] },
    				$$scope: { ctx }
    			}
    		});

    	return {
    		c() {
    			div1 = element("div");
    			div0 = element("div");
    			span = element("span");
    			t0 = text(t0_value);
    			t1 = text(" options");
    			t2 = space();
    			create_component(navbutton.$$.fragment);
    			attr(span, "class", "FiltersHeader__options svelte-1a9tewu");
    			attr(div0, "class", "FiltersHeader__body svelte-1a9tewu");
    			attr(div1, "class", "FiltersHeader svelte-1a9tewu");
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, div0);
    			append(div0, span);
    			append(span, t0);
    			append(span, t1);
    			append(div1, t2);
    			mount_component(navbutton, div1, null);
    			current = true;
    		},
    		p(ctx, [dirty]) {
    			if ((!current || dirty & /*$_filteredVariants*/ 1) && t0_value !== (t0_value = /*$_filteredVariants*/ ctx[0].length + "")) set_data(t0, t0_value);
    			const navbutton_changes = {};

    			if (dirty & /*$$scope*/ 4) {
    				navbutton_changes.$$scope = { dirty, ctx };
    			}

    			navbutton.$set(navbutton_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(navbutton.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(navbutton.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div1);
    			destroy_component(navbutton);
    		}
    	};
    }

    function instance$h($$self, $$props, $$invalidate) {
    	let $_filteredVariants;
    	component_subscribe($$self, _filteredVariants, $$value => $$invalidate(0, $_filteredVariants = $$value));

    	function handleFilter() {
    		navTo(Page.Filters);
    	}

    	return [$_filteredVariants, handleFilter];
    }

    class FiltersHeader extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$h, create_fragment$i, safe_not_equal, {}, add_css$h);
    	}
    }

    /* src/components/SwatchSelectedCard.svelte generated by Svelte v3.59.2 */

    function add_css$g(target) {
    	append_styles(target, "svelte-1d3qqm0", ".SwatchSelectedCard.svelte-1d3qqm0.svelte-1d3qqm0{position:relative;width:50px;height:50px;border:1px solid #edece8}@media(max-width: 750px){.SwatchSelectedCard.svelte-1d3qqm0.svelte-1d3qqm0{width:40px;height:40px}}.SwatchSelectedCard__remove.svelte-1d3qqm0.svelte-1d3qqm0{width:18px;height:18px;box-shadow:0 0 8px rgba(0, 0, 0, 0.1490196078);border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;top:-5px;right:-5px;background-color:#fff;transform:rotate(45deg)}.SwatchSelectedCard__remove.svelte-1d3qqm0.svelte-1d3qqm0:before{content:\"\";position:absolute;top:50%;left:50%;background:#222;transform:translate(-50%, -50%);width:1px;height:12px}.SwatchSelectedCard__remove.svelte-1d3qqm0.svelte-1d3qqm0:after{content:\"\";position:absolute;top:50%;left:50%;background:#222;transform:translate(-50%, -50%);width:12px;height:1px}.SwatchSelectedCard.svelte-1d3qqm0 img.svelte-1d3qqm0{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;width:100%;height:100%}");
    }

    function create_fragment$h(ctx) {
    	let div;
    	let button;
    	let t;
    	let img;
    	let img_src_value;
    	let mounted;
    	let dispose;

    	return {
    		c() {
    			div = element("div");
    			button = element("button");
    			t = space();
    			img = element("img");
    			attr(button, "class", "SwatchSelectedCard__remove svelte-1d3qqm0");
    			if (!src_url_equal(img.src, img_src_value = /*variant*/ ctx[0].image)) attr(img, "src", img_src_value);
    			attr(img, "alt", "");
    			attr(img, "class", "svelte-1d3qqm0");
    			attr(div, "class", "SwatchSelectedCard svelte-1d3qqm0");
    		},
    		m(target, anchor) {
    			insert(target, div, anchor);
    			append(div, button);
    			append(div, t);
    			append(div, img);

    			if (!mounted) {
    				dispose = listen(button, "click", /*handleRemove*/ ctx[1]);
    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*variant*/ 1 && !src_url_equal(img.src, img_src_value = /*variant*/ ctx[0].image)) {
    				attr(img, "src", img_src_value);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$g($$self, $$props, $$invalidate) {
    	let { variant } = $$props;

    	function handleRemove() {
    		_selectedVariants.update(current => {
    			delete current[variant.id];
    			return current;
    		});
    	}

    	$$self.$$set = $$props => {
    		if ('variant' in $$props) $$invalidate(0, variant = $$props.variant);
    	};

    	return [variant, handleRemove];
    }

    class SwatchSelectedCard extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$g, create_fragment$h, safe_not_equal, { variant: 0 }, add_css$g);
    	}
    }

    /* src/components/SwatchesSelected.svelte generated by Svelte v3.59.2 */

    function add_css$f(target) {
    	append_styles(target, "svelte-ordv11", ".SwatchesSelected.svelte-ordv11{background:#fff;padding:20px;display:flex;justify-content:space-between}.SwatchesSelected__label.svelte-ordv11{font-size:13px}.SwatchesSelected__cards.svelte-ordv11{display:flex;-moz-column-gap:10px;column-gap:10px}.SwatchesSelected__empty-variant.svelte-ordv11{width:50px;height:50px;border:1px dashed #707070;display:block !important}@media(max-width: 750px){.SwatchesSelected__empty-variant.svelte-ordv11{width:40px;height:40px}}");
    }

    function get_each_context$3(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[1] = list[i];
    	child_ctx[3] = i;
    	return child_ctx;
    }

    // (14:12) {:else}
    function create_else_block$1(ctx) {
    	let div;

    	return {
    		c() {
    			div = element("div");
    			attr(div, "class", "SwatchesSelected__empty-variant svelte-ordv11");
    		},
    		m(target, anchor) {
    			insert(target, div, anchor);
    		},
    		p: noop,
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div);
    		}
    	};
    }

    // (12:12) {#if $_selectedVariants[i]}
    function create_if_block$4(ctx) {
    	let swatchselectedcard;
    	let current;

    	swatchselectedcard = new SwatchSelectedCard({
    			props: {
    				variant: /*$_selectedVariants*/ ctx[0][/*i*/ ctx[3]]
    			}
    		});

    	return {
    		c() {
    			create_component(swatchselectedcard.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(swatchselectedcard, target, anchor);
    			current = true;
    		},
    		p(ctx, dirty) {
    			const swatchselectedcard_changes = {};
    			if (dirty & /*$_selectedVariants*/ 1) swatchselectedcard_changes.variant = /*$_selectedVariants*/ ctx[0][/*i*/ ctx[3]];
    			swatchselectedcard.$set(swatchselectedcard_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(swatchselectedcard.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(swatchselectedcard.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(swatchselectedcard, detaching);
    		}
    	};
    }

    // (11:8) {#each {length: 5} as _, i}
    function create_each_block$3(ctx) {
    	let current_block_type_index;
    	let if_block;
    	let if_block_anchor;
    	let current;
    	const if_block_creators = [create_if_block$4, create_else_block$1];
    	const if_blocks = [];

    	function select_block_type(ctx, dirty) {
    		if (/*$_selectedVariants*/ ctx[0][/*i*/ ctx[3]]) return 0;
    		return 1;
    	}

    	current_block_type_index = select_block_type(ctx);
    	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

    	return {
    		c() {
    			if_block.c();
    			if_block_anchor = empty();
    		},
    		m(target, anchor) {
    			if_blocks[current_block_type_index].m(target, anchor);
    			insert(target, if_block_anchor, anchor);
    			current = true;
    		},
    		p(ctx, dirty) {
    			let previous_block_index = current_block_type_index;
    			current_block_type_index = select_block_type(ctx);

    			if (current_block_type_index === previous_block_index) {
    				if_blocks[current_block_type_index].p(ctx, dirty);
    			} else {
    				group_outros();

    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
    					if_blocks[previous_block_index] = null;
    				});

    				check_outros();
    				if_block = if_blocks[current_block_type_index];

    				if (!if_block) {
    					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    					if_block.c();
    				} else {
    					if_block.p(ctx, dirty);
    				}

    				transition_in(if_block, 1);
    				if_block.m(if_block_anchor.parentNode, if_block_anchor);
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(if_block);
    			current = true;
    		},
    		o(local) {
    			transition_out(if_block);
    			current = false;
    		},
    		d(detaching) {
    			if_blocks[current_block_type_index].d(detaching);
    			if (detaching) detach(if_block_anchor);
    		}
    	};
    }

    function create_fragment$g(ctx) {
    	let div2;
    	let div0;
    	let t1;
    	let div1;
    	let current;
    	let each_value = { length: 5 };
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
    	}

    	const out = i => transition_out(each_blocks[i], 1, 1, () => {
    		each_blocks[i] = null;
    	});

    	return {
    		c() {
    			div2 = element("div");
    			div0 = element("div");
    			div0.textContent = "Select Up To Five:";
    			t1 = space();
    			div1 = element("div");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			attr(div0, "class", "SwatchesSelected__label svelte-ordv11");
    			attr(div1, "class", "SwatchesSelected__cards svelte-ordv11");
    			attr(div2, "class", "SwatchesSelected svelte-ordv11");
    		},
    		m(target, anchor) {
    			insert(target, div2, anchor);
    			append(div2, div0);
    			append(div2, t1);
    			append(div2, div1);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				if (each_blocks[i]) {
    					each_blocks[i].m(div1, null);
    				}
    			}

    			current = true;
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*$_selectedVariants*/ 1) {
    				each_value = { length: 5 };
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$3(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    						transition_in(each_blocks[i], 1);
    					} else {
    						each_blocks[i] = create_each_block$3(child_ctx);
    						each_blocks[i].c();
    						transition_in(each_blocks[i], 1);
    						each_blocks[i].m(div1, null);
    					}
    				}

    				group_outros();

    				for (i = each_value.length; i < each_blocks.length; i += 1) {
    					out(i);
    				}

    				check_outros();
    			}
    		},
    		i(local) {
    			if (current) return;

    			for (let i = 0; i < each_value.length; i += 1) {
    				transition_in(each_blocks[i]);
    			}

    			current = true;
    		},
    		o(local) {
    			each_blocks = each_blocks.filter(Boolean);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				transition_out(each_blocks[i]);
    			}

    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div2);
    			destroy_each(each_blocks, detaching);
    		}
    	};
    }

    function instance$f($$self, $$props, $$invalidate) {
    	let $_selectedVariants;
    	component_subscribe($$self, _selectedVariants, $$value => $$invalidate(0, $_selectedVariants = $$value));
    	return [$_selectedVariants];
    }

    class SwatchesSelected extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$f, create_fragment$g, safe_not_equal, {}, add_css$f);
    	}
    }

    /* src/components/Button.svelte generated by Svelte v3.59.2 */

    function add_css$e(target) {
    	append_styles(target, "svelte-5w8cyr", ".Button.svelte-5w8cyr{display:flex;border:none;cursor:pointer;padding:15px 40px;width:100%;align-items:center;justify-content:center;line-height:13px;text-align:center;transition:background 0.3s}.Button--primary.svelte-5w8cyr{background:#1e372f;letter-spacing:2px;color:#fff;text-transform:uppercase;font-weight:600;font-size:13px}.Button--primary.svelte-5w8cyr:hover{background:#4b5f59}.Button--primary.svelte-5w8cyr:disabled{background:#707070;cursor:default}.Button--inline.svelte-5w8cyr{text-decoration:underline;font-size:15px}.Button--inline.svelte-5w8cyr:hover{text-decoration:none}");
    }

    function create_fragment$f(ctx) {
    	let button;
    	let current;
    	let mounted;
    	let dispose;
    	const default_slot_template = /*#slots*/ ctx[4].default;
    	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[3], null);

    	return {
    		c() {
    			button = element("button");
    			if (default_slot) default_slot.c();
    			attr(button, "class", "Button svelte-5w8cyr");
    			button.disabled = /*disabled*/ ctx[0];
    			toggle_class(button, "Button--primary", !/*inline*/ ctx[1]);
    			toggle_class(button, "Button--inline", /*inline*/ ctx[1]);
    		},
    		m(target, anchor) {
    			insert(target, button, anchor);

    			if (default_slot) {
    				default_slot.m(button, null);
    			}

    			current = true;

    			if (!mounted) {
    				dispose = listen(button, "click", function () {
    					if (is_function(/*onClick*/ ctx[2])) /*onClick*/ ctx[2].apply(this, arguments);
    				});

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;

    			if (default_slot) {
    				if (default_slot.p && (!current || dirty & /*$$scope*/ 8)) {
    					update_slot_base(
    						default_slot,
    						default_slot_template,
    						ctx,
    						/*$$scope*/ ctx[3],
    						!current
    						? get_all_dirty_from_scope(/*$$scope*/ ctx[3])
    						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[3], dirty, null),
    						null
    					);
    				}
    			}

    			if (!current || dirty & /*disabled*/ 1) {
    				button.disabled = /*disabled*/ ctx[0];
    			}

    			if (!current || dirty & /*inline*/ 2) {
    				toggle_class(button, "Button--primary", !/*inline*/ ctx[1]);
    			}

    			if (!current || dirty & /*inline*/ 2) {
    				toggle_class(button, "Button--inline", /*inline*/ ctx[1]);
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(default_slot, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(default_slot, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(button);
    			if (default_slot) default_slot.d(detaching);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$e($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	let { disabled = false } = $$props;
    	let { inline = false } = $$props;

    	let { onClick = () => {
    		
    	} } = $$props;

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(0, disabled = $$props.disabled);
    		if ('inline' in $$props) $$invalidate(1, inline = $$props.inline);
    		if ('onClick' in $$props) $$invalidate(2, onClick = $$props.onClick);
    		if ('$$scope' in $$props) $$invalidate(3, $$scope = $$props.$$scope);
    	};

    	return [disabled, inline, onClick, $$scope, slots];
    }

    class Button extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$e, create_fragment$f, safe_not_equal, { disabled: 0, inline: 1, onClick: 2 }, add_css$e);
    	}
    }

    /* src/components/QuantityInput.svelte generated by Svelte v3.59.2 */

    function add_css$d(target) {
    	append_styles(target, "svelte-5agm48", ".QuantityInput.svelte-5agm48.svelte-5agm48{background:#fff;position:relative;width:25px;height:25px;border-radius:25px;border:none;box-shadow:0 0 8px rgba(0, 0, 0, 0.1490196078);display:flex;align-items:center;justify-content:center;min-width:0;min-height:0;padding:0;margin:0;color:#222;transition:width 0.15s ease-in}.QuantityInput.active.svelte-5agm48.svelte-5agm48{width:75px;justify-content:space-between}.QuantityInput__value.svelte-5agm48.svelte-5agm48{font-size:14px}.QuantityInput__button.svelte-5agm48.svelte-5agm48{width:25px;height:25px;position:relative;transition:transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0s, color 0.2s ease 0s;min-width:0;min-height:0;padding:0;margin:0;background-color:#fff !important;border:none;border-radius:25px}.QuantityInput__button-minus.svelte-5agm48.svelte-5agm48:after{content:\"\";position:absolute;top:50%;left:50%;background:#222;transform:translate(-50%, -50%);width:12px;height:1px}.QuantityInput__button-plus.svelte-5agm48.svelte-5agm48:before{content:\"\";position:absolute;top:50%;left:50%;background:#222;transform:translate(-50%, -50%);width:1px;height:12px}.QuantityInput__button-plus.svelte-5agm48.svelte-5agm48:after{content:\"\";position:absolute;top:50%;left:50%;background:#222;transform:translate(-50%, -50%);width:12px;height:1px}.QuantityInput.svelte-5agm48:not(.active) .QuantityInput__button-minus.svelte-5agm48,.QuantityInput.svelte-5agm48:not(.active) .QuantityInput__value.svelte-5agm48{display:none}");
    }

    function create_fragment$e(ctx) {
    	let div1;
    	let button0;
    	let t0;
    	let div0;
    	let t1;
    	let t2;
    	let button1;
    	let mounted;
    	let dispose;

    	return {
    		c() {
    			div1 = element("div");
    			button0 = element("button");
    			t0 = space();
    			div0 = element("div");
    			t1 = text(/*value*/ ctx[1]);
    			t2 = space();
    			button1 = element("button");
    			attr(button0, "class", "QuantityInput__button QuantityInput__button-minus svelte-5agm48");
    			attr(div0, "class", "QuantityInput__value svelte-5agm48");
    			attr(button1, "class", "QuantityInput__button QuantityInput__button-plus svelte-5agm48");
    			button1.disabled = /*disabled*/ ctx[0];
    			attr(div1, "class", "QuantityInput svelte-5agm48");
    			toggle_class(div1, "active", /*value*/ ctx[1] > 0);
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, button0);
    			append(div1, t0);
    			append(div1, div0);
    			append(div0, t1);
    			append(div1, t2);
    			append(div1, button1);

    			if (!mounted) {
    				dispose = [
    					listen(button0, "click", function () {
    						if (is_function(/*onMinus*/ ctx[3])) /*onMinus*/ ctx[3].apply(this, arguments);
    					}),
    					listen(button1, "click", function () {
    						if (is_function(/*onPlus*/ ctx[2])) /*onPlus*/ ctx[2].apply(this, arguments);
    					})
    				];

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;
    			if (dirty & /*value*/ 2) set_data(t1, /*value*/ ctx[1]);

    			if (dirty & /*disabled*/ 1) {
    				button1.disabled = /*disabled*/ ctx[0];
    			}

    			if (dirty & /*value*/ 2) {
    				toggle_class(div1, "active", /*value*/ ctx[1] > 0);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div1);
    			mounted = false;
    			run_all(dispose);
    		}
    	};
    }

    function instance$d($$self, $$props, $$invalidate) {
    	let { disabled = false } = $$props;
    	let { value = 0 } = $$props;

    	let { onPlus = () => {
    		
    	} } = $$props;

    	let { onMinus = () => {
    		
    	} } = $$props;

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(0, disabled = $$props.disabled);
    		if ('value' in $$props) $$invalidate(1, value = $$props.value);
    		if ('onPlus' in $$props) $$invalidate(2, onPlus = $$props.onPlus);
    		if ('onMinus' in $$props) $$invalidate(3, onMinus = $$props.onMinus);
    	};

    	return [disabled, value, onPlus, onMinus];
    }

    class QuantityInput extends SvelteComponent {
    	constructor(options) {
    		super();

    		init(
    			this,
    			options,
    			instance$d,
    			create_fragment$e,
    			safe_not_equal,
    			{
    				disabled: 0,
    				value: 1,
    				onPlus: 2,
    				onMinus: 3
    			},
    			add_css$d
    		);
    	}
    }

    /* src/components/FabricCard.svelte generated by Svelte v3.59.2 */

    function add_css$c(target) {
    	append_styles(target, "svelte-xh08m5", ".FabricCard.svelte-xh08m5.svelte-xh08m5{display:flex;flex-direction:column;row-gap:10px;position:relative}.FabricCard.svelte-xh08m5>.svelte-xh08m5:empty{display:none}.FabricCard__quantity.svelte-xh08m5.svelte-xh08m5{position:absolute;top:10px;right:10px}.FabricCard__image.svelte-xh08m5.svelte-xh08m5{aspect-ratio:1;width:100%}.FabricCard__image.svelte-xh08m5 img.svelte-xh08m5{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;width:100%;height:100%}.FabricCard__title.svelte-xh08m5.svelte-xh08m5{display:block;text-transform:uppercase;font-size:16px}.FabricCard__title.svelte-xh08m5>span.svelte-xh08m5{font-size:12px}.FabricCard__types.svelte-xh08m5.svelte-xh08m5{font-size:14px}");
    }

    // (33:52) {#if variant.material != "" && variant.material != " "}
    function create_if_block$3(ctx) {
    	let span;
    	let t0;
    	let t1_value = /*variant*/ ctx[0].material + "";
    	let t1;
    	let t2;

    	return {
    		c() {
    			span = element("span");
    			t0 = text("(");
    			t1 = text(t1_value);
    			t2 = text(")");
    			attr(span, "class", "svelte-xh08m5");
    		},
    		m(target, anchor) {
    			insert(target, span, anchor);
    			append(span, t0);
    			append(span, t1);
    			append(span, t2);
    		},
    		p(ctx, dirty) {
    			if (dirty & /*variant*/ 1 && t1_value !== (t1_value = /*variant*/ ctx[0].material + "")) set_data(t1, t1_value);
    		},
    		d(detaching) {
    			if (detaching) detach(span);
    		}
    	};
    }

    function create_fragment$d(ctx) {
    	let div2;
    	let div0;
    	let quantityinput;
    	let t0;
    	let div1;
    	let img;
    	let img_src_value;
    	let t1;
    	let span0;
    	let t2_value = /*variant*/ ctx[0].title + "";
    	let t2;
    	let t3;
    	let t4;
    	let span1;
    	let t5_value = [/*variant*/ ctx[0].type, .../*variant*/ ctx[0].features].filter(Boolean).join(' / ') + "";
    	let t5;
    	let current;

    	quantityinput = new QuantityInput({
    			props: {
    				value: /*quantity*/ ctx[1],
    				disabled: Object.keys(/*$_selectedVariants*/ ctx[2]).length >= 5,
    				onPlus: /*handlePlus*/ ctx[3],
    				onMinus: /*handleMinus*/ ctx[4]
    			}
    		});

    	let if_block = /*variant*/ ctx[0].material != "" && /*variant*/ ctx[0].material != " " && create_if_block$3(ctx);

    	return {
    		c() {
    			div2 = element("div");
    			div0 = element("div");
    			create_component(quantityinput.$$.fragment);
    			t0 = space();
    			div1 = element("div");
    			img = element("img");
    			t1 = space();
    			span0 = element("span");
    			t2 = text(t2_value);
    			t3 = space();
    			if (if_block) if_block.c();
    			t4 = space();
    			span1 = element("span");
    			t5 = text(t5_value);
    			attr(div0, "class", "FabricCard__quantity svelte-xh08m5");
    			if (!src_url_equal(img.src, img_src_value = /*variant*/ ctx[0].image)) attr(img, "src", img_src_value);
    			attr(img, "alt", "");
    			attr(img, "class", "svelte-xh08m5");
    			attr(div1, "class", "FabricCard__image svelte-xh08m5");
    			attr(span0, "class", "FabricCard__title svelte-xh08m5");
    			attr(span1, "class", "FabricCard__types svelte-xh08m5");
    			attr(div2, "class", "FabricCard svelte-xh08m5");
    		},
    		m(target, anchor) {
    			insert(target, div2, anchor);
    			append(div2, div0);
    			mount_component(quantityinput, div0, null);
    			append(div2, t0);
    			append(div2, div1);
    			append(div1, img);
    			append(div2, t1);
    			append(div2, span0);
    			append(span0, t2);
    			append(span0, t3);
    			if (if_block) if_block.m(span0, null);
    			append(div2, t4);
    			append(div2, span1);
    			append(span1, t5);
    			current = true;
    		},
    		p(ctx, [dirty]) {
    			const quantityinput_changes = {};
    			if (dirty & /*quantity*/ 2) quantityinput_changes.value = /*quantity*/ ctx[1];
    			if (dirty & /*$_selectedVariants*/ 4) quantityinput_changes.disabled = Object.keys(/*$_selectedVariants*/ ctx[2]).length >= 5;
    			quantityinput.$set(quantityinput_changes);

    			if (!current || dirty & /*variant*/ 1 && !src_url_equal(img.src, img_src_value = /*variant*/ ctx[0].image)) {
    				attr(img, "src", img_src_value);
    			}

    			if ((!current || dirty & /*variant*/ 1) && t2_value !== (t2_value = /*variant*/ ctx[0].title + "")) set_data(t2, t2_value);

    			if (/*variant*/ ctx[0].material != "" && /*variant*/ ctx[0].material != " ") {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$3(ctx);
    					if_block.c();
    					if_block.m(span0, null);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}

    			if ((!current || dirty & /*variant*/ 1) && t5_value !== (t5_value = [/*variant*/ ctx[0].type, .../*variant*/ ctx[0].features].filter(Boolean).join(' / ') + "")) set_data(t5, t5_value);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(quantityinput.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(quantityinput.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div2);
    			destroy_component(quantityinput);
    			if (if_block) if_block.d();
    		}
    	};
    }

    function instance$c($$self, $$props, $$invalidate) {
    	let $_selectedVariants;
    	component_subscribe($$self, _selectedVariants, $$value => $$invalidate(2, $_selectedVariants = $$value));
    	let { variant } = $$props;
    	let quantity = 0;

    	function handlePlus() {
    		if ($_selectedVariants.length < 5) {
    			$$invalidate(1, quantity += 1);

    			_selectedVariants.update(current => {
    				current.push(variant);
    				return current;
    			});
    		}
    	}

    	function handleMinus() {
    		if (quantity >= 1) {
    			_selectedVariants.update(current => {
    				const idx = current.findIndex(item => item.id === variant.id);

    				if (idx > -1) {
    					current.splice(idx, 1);
    				}

    				return current;
    			});

    			$$invalidate(1, quantity -= 1);
    		}
    	}

    	$$self.$$set = $$props => {
    		if ('variant' in $$props) $$invalidate(0, variant = $$props.variant);
    	};

    	return [variant, quantity, $_selectedVariants, handlePlus, handleMinus];
    }

    class FabricCard extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$c, create_fragment$d, safe_not_equal, { variant: 0 }, add_css$c);
    	}
    }

    /* src/components/SwatchesCart.svelte generated by Svelte v3.59.2 */

    function add_css$b(target) {
    	append_styles(target, "svelte-1gwcw17", ".SwatchesCart.svelte-1gwcw17{height:100%;display:flex;flex-direction:column}.SwatchesCart__body.svelte-1gwcw17{flex:1;overflow-y:auto;overflow-x:hidden}.SwatchesCart__variants.svelte-1gwcw17{display:grid;grid-template-columns:1fr 1fr;-moz-column-gap:20px;column-gap:20px;row-gap:40px;overflow-y:auto;padding:20px}");
    }

    function get_each_context$2(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[3] = list[i];
    	return child_ctx;
    }

    // (26:12) {#each $_filteredVariants as variant}
    function create_each_block$2(ctx) {
    	let fabriccard;
    	let current;
    	fabriccard = new FabricCard({ props: { variant: /*variant*/ ctx[3] } });

    	return {
    		c() {
    			create_component(fabriccard.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(fabriccard, target, anchor);
    			current = true;
    		},
    		p(ctx, dirty) {
    			const fabriccard_changes = {};
    			if (dirty & /*$_filteredVariants*/ 2) fabriccard_changes.variant = /*variant*/ ctx[3];
    			fabriccard.$set(fabriccard_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(fabriccard.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(fabriccard.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(fabriccard, detaching);
    		}
    	};
    }

    // (35:8) <Button onClick={handleSubmit} disabled={Object.keys($_selectedVariants).length === 0} >
    function create_default_slot$3(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("Order Swatches");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    function create_fragment$c(ctx) {
    	let div4;
    	let div0;
    	let filtersheader;
    	let t0;
    	let div2;
    	let div1;
    	let t1;
    	let div3;
    	let swatchesselected;
    	let t2;
    	let button;
    	let current;
    	filtersheader = new FiltersHeader({});
    	let each_value = /*$_filteredVariants*/ ctx[1];
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
    	}

    	const out = i => transition_out(each_blocks[i], 1, 1, () => {
    		each_blocks[i] = null;
    	});

    	swatchesselected = new SwatchesSelected({});

    	button = new Button({
    			props: {
    				onClick: /*handleSubmit*/ ctx[2],
    				disabled: Object.keys(/*$_selectedVariants*/ ctx[0]).length === 0,
    				$$slots: { default: [create_default_slot$3] },
    				$$scope: { ctx }
    			}
    		});

    	return {
    		c() {
    			div4 = element("div");
    			div0 = element("div");
    			create_component(filtersheader.$$.fragment);
    			t0 = space();
    			div2 = element("div");
    			div1 = element("div");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			t1 = space();
    			div3 = element("div");
    			create_component(swatchesselected.$$.fragment);
    			t2 = space();
    			create_component(button.$$.fragment);
    			attr(div0, "class", "SwatchesCart__header");
    			attr(div1, "class", "SwatchesCart__variants svelte-1gwcw17");
    			attr(div2, "class", "SwatchesCart__body svelte-1gwcw17");
    			attr(div3, "class", "SwatchesCart__footer");
    			attr(div4, "class", "SwatchesCart svelte-1gwcw17");
    		},
    		m(target, anchor) {
    			insert(target, div4, anchor);
    			append(div4, div0);
    			mount_component(filtersheader, div0, null);
    			append(div4, t0);
    			append(div4, div2);
    			append(div2, div1);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				if (each_blocks[i]) {
    					each_blocks[i].m(div1, null);
    				}
    			}

    			append(div4, t1);
    			append(div4, div3);
    			mount_component(swatchesselected, div3, null);
    			append(div3, t2);
    			mount_component(button, div3, null);
    			current = true;
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*$_filteredVariants*/ 2) {
    				each_value = /*$_filteredVariants*/ ctx[1];
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$2(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    						transition_in(each_blocks[i], 1);
    					} else {
    						each_blocks[i] = create_each_block$2(child_ctx);
    						each_blocks[i].c();
    						transition_in(each_blocks[i], 1);
    						each_blocks[i].m(div1, null);
    					}
    				}

    				group_outros();

    				for (i = each_value.length; i < each_blocks.length; i += 1) {
    					out(i);
    				}

    				check_outros();
    			}

    			const button_changes = {};
    			if (dirty & /*$_selectedVariants*/ 1) button_changes.disabled = Object.keys(/*$_selectedVariants*/ ctx[0]).length === 0;

    			if (dirty & /*$$scope*/ 64) {
    				button_changes.$$scope = { dirty, ctx };
    			}

    			button.$set(button_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(filtersheader.$$.fragment, local);

    			for (let i = 0; i < each_value.length; i += 1) {
    				transition_in(each_blocks[i]);
    			}

    			transition_in(swatchesselected.$$.fragment, local);
    			transition_in(button.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(filtersheader.$$.fragment, local);
    			each_blocks = each_blocks.filter(Boolean);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				transition_out(each_blocks[i]);
    			}

    			transition_out(swatchesselected.$$.fragment, local);
    			transition_out(button.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div4);
    			destroy_component(filtersheader);
    			destroy_each(each_blocks, detaching);
    			destroy_component(swatchesselected);
    			destroy_component(button);
    		}
    	};
    }

    function instance$b($$self, $$props, $$invalidate) {
    	let $_selectedVariants;
    	let $_filteredVariants;
    	component_subscribe($$self, _selectedVariants, $$value => $$invalidate(0, $_selectedVariants = $$value));
    	component_subscribe($$self, _filteredVariants, $$value => $$invalidate(1, $_filteredVariants = $$value));

    	function handleSubmit() {
    		navTo(Page.Form);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*$_selectedVariants*/ 1) {
    			{
    				console.log($_selectedVariants);
    			}
    		}
    	};

    	return [$_selectedVariants, $_filteredVariants, handleSubmit];
    }

    class SwatchesCart extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$b, create_fragment$c, safe_not_equal, {}, add_css$b);
    	}
    }

    /* src/components/pages/CartPage.svelte generated by Svelte v3.59.2 */

    function add_css$a(target) {
    	append_styles(target, "svelte-1vp1a3u", ".CartPage.svelte-1vp1a3u{height:100%}");
    }

    function create_fragment$b(ctx) {
    	let div;
    	let swatchescart;
    	let current;
    	swatchescart = new SwatchesCart({});

    	return {
    		c() {
    			div = element("div");
    			create_component(swatchescart.$$.fragment);
    			attr(div, "class", "CartPage svelte-1vp1a3u");
    		},
    		m(target, anchor) {
    			insert(target, div, anchor);
    			mount_component(swatchescart, div, null);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(swatchescart.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(swatchescart.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div);
    			destroy_component(swatchescart);
    		}
    	};
    }

    class CartPage extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, null, create_fragment$b, safe_not_equal, {}, add_css$a);
    	}
    }

    /* src/components/ColorCheckbox.svelte generated by Svelte v3.59.2 */

    function add_css$9(target) {
    	append_styles(target, "svelte-fn613z", ".ColorCheckbox.svelte-fn613z.svelte-fn613z{display:flex;align-items:center;-moz-column-gap:10px;column-gap:10px}.ColorCheckbox__indicator.svelte-fn613z.svelte-fn613z{min-width:25px;min-height:25px;max-width:25px;max-height:25px;width:25px;height:25px;display:block;border-radius:100%;border:1px solid transparent;padding:3px}.ColorCheckbox__indicator.svelte-fn613z>span.svelte-fn613z{border-radius:100%;width:100%;height:100%;display:block;border:1px solid #bdbdbd}.ColorCheckbox__label.svelte-fn613z.svelte-fn613z{text-transform:uppercase;font-size:14px;letter-spacing:1.4px;text-align:left}.ColorCheckbox__label.svelte-fn613z>span.svelte-fn613z{font-size:13px;opacity:0.7}.ColorCheckbox__label.svelte-fn613z>span.svelte-fn613z:before{content:\" \"}.ColorCheckbox--selected.svelte-fn613z .ColorCheckbox__indicator.svelte-fn613z{border-color:#000}.ColorCheckbox.svelte-fn613z.svelte-fn613z:disabled{pointer-events:none;opacity:0.7}");
    }

    function create_fragment$a(ctx) {
    	let button;
    	let span1;
    	let span0;
    	let t0;
    	let span3;
    	let t1;
    	let span2;
    	let t2;
    	let mounted;
    	let dispose;

    	return {
    		c() {
    			button = element("button");
    			span1 = element("span");
    			span0 = element("span");
    			t0 = space();
    			span3 = element("span");
    			t1 = text(/*label*/ ctx[1]);
    			span2 = element("span");
    			t2 = text(/*suffix*/ ctx[2]);
    			set_style(span0, "background-color", /*color*/ ctx[3]);
    			attr(span0, "class", "svelte-fn613z");
    			attr(span1, "class", "ColorCheckbox__indicator svelte-fn613z");
    			attr(span2, "class", "svelte-fn613z");
    			attr(span3, "class", "ColorCheckbox__label svelte-fn613z");
    			attr(button, "class", "ColorCheckbox svelte-fn613z");
    			button.disabled = /*disabled*/ ctx[0];
    			toggle_class(button, "ColorCheckbox--selected", /*selected*/ ctx[4]);
    		},
    		m(target, anchor) {
    			insert(target, button, anchor);
    			append(button, span1);
    			append(span1, span0);
    			append(button, t0);
    			append(button, span3);
    			append(span3, t1);
    			append(span3, span2);
    			append(span2, t2);

    			if (!mounted) {
    				dispose = listen(button, "click", function () {
    					if (is_function(/*onClick*/ ctx[5])) /*onClick*/ ctx[5].apply(this, arguments);
    				});

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;

    			if (dirty & /*color*/ 8) {
    				set_style(span0, "background-color", /*color*/ ctx[3]);
    			}

    			if (dirty & /*label*/ 2) set_data(t1, /*label*/ ctx[1]);
    			if (dirty & /*suffix*/ 4) set_data(t2, /*suffix*/ ctx[2]);

    			if (dirty & /*disabled*/ 1) {
    				button.disabled = /*disabled*/ ctx[0];
    			}

    			if (dirty & /*selected*/ 16) {
    				toggle_class(button, "ColorCheckbox--selected", /*selected*/ ctx[4]);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(button);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$a($$self, $$props, $$invalidate) {
    	let { disabled = false } = $$props;
    	let { label } = $$props;
    	let { suffix } = $$props;
    	let { color } = $$props;
    	let { selected = false } = $$props;

    	let { onClick = () => {
    		
    	} } = $$props;

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(0, disabled = $$props.disabled);
    		if ('label' in $$props) $$invalidate(1, label = $$props.label);
    		if ('suffix' in $$props) $$invalidate(2, suffix = $$props.suffix);
    		if ('color' in $$props) $$invalidate(3, color = $$props.color);
    		if ('selected' in $$props) $$invalidate(4, selected = $$props.selected);
    		if ('onClick' in $$props) $$invalidate(5, onClick = $$props.onClick);
    	};

    	return [disabled, label, suffix, color, selected, onClick];
    }

    class ColorCheckbox extends SvelteComponent {
    	constructor(options) {
    		super();

    		init(
    			this,
    			options,
    			instance$a,
    			create_fragment$a,
    			safe_not_equal,
    			{
    				disabled: 0,
    				label: 1,
    				suffix: 2,
    				color: 3,
    				selected: 4,
    				onClick: 5
    			},
    			add_css$9
    		);
    	}
    }

    /* src/components/Checkbox.svelte generated by Svelte v3.59.2 */

    function add_css$8(target) {
    	append_styles(target, "svelte-12xma7u", ".Checkbox.svelte-12xma7u.svelte-12xma7u.svelte-12xma7u{display:flex;align-items:center;-moz-column-gap:10px;column-gap:10px}.Checkbox__indicator.svelte-12xma7u.svelte-12xma7u.svelte-12xma7u{min-width:25px;min-height:25px;max-width:25px;max-height:25px;width:25px;height:25px;display:block;border:1px solid #000;padding:3px}.Checkbox__indicator.svelte-12xma7u>span.svelte-12xma7u.svelte-12xma7u{width:100%;height:100%;display:block}.Checkbox__label.svelte-12xma7u.svelte-12xma7u.svelte-12xma7u{font-size:14px;letter-spacing:1px;text-align:left}.Checkbox__label.svelte-12xma7u>span.svelte-12xma7u.svelte-12xma7u{font-size:13px;opacity:0.7}.Checkbox__label.svelte-12xma7u>span.svelte-12xma7u.svelte-12xma7u:before{content:\" \"}.Checkbox--selected.svelte-12xma7u .Checkbox__indicator.svelte-12xma7u>span.svelte-12xma7u{background:#000}.Checkbox.svelte-12xma7u.svelte-12xma7u.svelte-12xma7u:disabled{pointer-events:none;opacity:0.7}");
    }

    function create_fragment$9(ctx) {
    	let button;
    	let span1;
    	let t0;
    	let span3;
    	let t1;
    	let span2;
    	let t2;
    	let mounted;
    	let dispose;

    	return {
    		c() {
    			button = element("button");
    			span1 = element("span");
    			span1.innerHTML = `<span class="svelte-12xma7u"></span>`;
    			t0 = space();
    			span3 = element("span");
    			t1 = text(/*label*/ ctx[1]);
    			span2 = element("span");
    			t2 = text(/*suffix*/ ctx[2]);
    			attr(span1, "class", "Checkbox__indicator svelte-12xma7u");
    			attr(span2, "class", "svelte-12xma7u");
    			attr(span3, "class", "Checkbox__label svelte-12xma7u");
    			attr(button, "class", "Checkbox svelte-12xma7u");
    			button.disabled = /*disabled*/ ctx[0];
    			toggle_class(button, "Checkbox--selected", /*selected*/ ctx[3]);
    		},
    		m(target, anchor) {
    			insert(target, button, anchor);
    			append(button, span1);
    			append(button, t0);
    			append(button, span3);
    			append(span3, t1);
    			append(span3, span2);
    			append(span2, t2);

    			if (!mounted) {
    				dispose = listen(button, "click", function () {
    					if (is_function(/*onClick*/ ctx[4])) /*onClick*/ ctx[4].apply(this, arguments);
    				});

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;
    			if (dirty & /*label*/ 2) set_data(t1, /*label*/ ctx[1]);
    			if (dirty & /*suffix*/ 4) set_data(t2, /*suffix*/ ctx[2]);

    			if (dirty & /*disabled*/ 1) {
    				button.disabled = /*disabled*/ ctx[0];
    			}

    			if (dirty & /*selected*/ 8) {
    				toggle_class(button, "Checkbox--selected", /*selected*/ ctx[3]);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(button);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$9($$self, $$props, $$invalidate) {
    	let { disabled = false } = $$props;
    	let { label } = $$props;
    	let { suffix } = $$props;
    	let { selected = false } = $$props;

    	let { onClick = () => {
    		
    	} } = $$props;

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(0, disabled = $$props.disabled);
    		if ('label' in $$props) $$invalidate(1, label = $$props.label);
    		if ('suffix' in $$props) $$invalidate(2, suffix = $$props.suffix);
    		if ('selected' in $$props) $$invalidate(3, selected = $$props.selected);
    		if ('onClick' in $$props) $$invalidate(4, onClick = $$props.onClick);
    	};

    	return [disabled, label, suffix, selected, onClick];
    }

    class Checkbox extends SvelteComponent {
    	constructor(options) {
    		super();

    		init(
    			this,
    			options,
    			instance$9,
    			create_fragment$9,
    			safe_not_equal,
    			{
    				disabled: 0,
    				label: 1,
    				suffix: 2,
    				selected: 3,
    				onClick: 4
    			},
    			add_css$8
    		);
    	}
    }

    class FiltersController {
        _filter() {
            const variants = get_store_value(_variants);
            const filters = get_store_value(_selectedFilters);
            _filteredVariants.update(() => {
                if (Object.keys(filters).length === 0)
                    return variants;
                return variants.filter(variant => {
                    return Object.entries(filters).some(([type, values]) => {
                        if (Array.isArray(variant[type])) {
                            return values.some(value => variant[type].includes(value));
                        }
                        else {
                            return values.includes(variant[type]);
                        }
                    });
                });
            });
        }
        _clear() {
            _selectedFilters.update(() => ({}));
        }
        apply() {
            this._filter();
            navTo(Page.Cart);
        }
        select(type, value) {
            _selectedFilters.update((current) => {
                if (type in current) {
                    if (current[type].includes(value)) {
                        current[type] = current[type].filter(item => item !== value);
                        current[type].length === 0 && delete current[type];
                    }
                    else {
                        current[type].push(value);
                    }
                }
                else {
                    current[type] = [value];
                }
                return current;
            });
        }
        cancel() {
            this._clear();
            this._filter();
            navTo(Page.Cart);
        }
    }
    var FiltersController$1 = new FiltersController();

    /* src/components/pages/FiltersPage.svelte generated by Svelte v3.59.2 */

    function add_css$7(target) {
    	append_styles(target, "svelte-1vw6gdb", ".FiltersPage.svelte-1vw6gdb{height:100%;display:flex;flex-direction:column}.FiltersPage__body.svelte-1vw6gdb{flex:1;overflow-y:auto;overflow-x:hidden;padding:20px}.FiltersPage__label.svelte-1vw6gdb{text-transform:uppercase;font-size:14px;letter-spacing:1.5px;margin-bottom:15px}.FiltersPage__grid.svelte-1vw6gdb{display:grid;grid-template-columns:repeat(3, 1fr);-moz-column-gap:20px;column-gap:20px;row-gap:12px;margin-bottom:40px}");
    }

    function get_each_context$1(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[11] = list[i][0];
    	child_ctx[12] = list[i][1];
    	return child_ctx;
    }

    function get_each_context_1(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[11] = list[i][0];
    	child_ctx[12] = list[i][1];
    	return child_ctx;
    }

    function get_each_context_2(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[11] = list[i][0];
    	child_ctx[12] = list[i][1];
    	return child_ctx;
    }

    function get_each_context_3(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[11] = list[i][0];
    	child_ctx[12] = list[i][1];
    	return child_ctx;
    }

    // (13:12) {#each Object.entries($_colorFilters) as [label, payload]}
    function create_each_block_3(ctx) {
    	let colorcheckbox;
    	let current;

    	function func() {
    		return /*func*/ ctx[5](/*label*/ ctx[11]);
    	}

    	colorcheckbox = new ColorCheckbox({
    			props: {
    				label: /*label*/ ctx[11],
    				suffix: /*payload*/ ctx[12].quantity,
    				color: /*payload*/ ctx[12].hex,
    				selected: /*$_selectedFilters*/ ctx[1]['color']?.includes(/*label*/ ctx[11]),
    				onClick: func
    			}
    		});

    	return {
    		c() {
    			create_component(colorcheckbox.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(colorcheckbox, target, anchor);
    			current = true;
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			const colorcheckbox_changes = {};
    			if (dirty & /*$_colorFilters*/ 1) colorcheckbox_changes.label = /*label*/ ctx[11];
    			if (dirty & /*$_colorFilters*/ 1) colorcheckbox_changes.suffix = /*payload*/ ctx[12].quantity;
    			if (dirty & /*$_colorFilters*/ 1) colorcheckbox_changes.color = /*payload*/ ctx[12].hex;
    			if (dirty & /*$_selectedFilters, $_colorFilters*/ 3) colorcheckbox_changes.selected = /*$_selectedFilters*/ ctx[1]['color']?.includes(/*label*/ ctx[11]);
    			if (dirty & /*$_colorFilters*/ 1) colorcheckbox_changes.onClick = func;
    			colorcheckbox.$set(colorcheckbox_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(colorcheckbox.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(colorcheckbox.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(colorcheckbox, detaching);
    		}
    	};
    }

    // (24:12) {#each Object.entries($_featureFilters) as [label, payload]}
    function create_each_block_2(ctx) {
    	let checkbox;
    	let current;

    	function func_1() {
    		return /*func_1*/ ctx[6](/*label*/ ctx[11]);
    	}

    	checkbox = new Checkbox({
    			props: {
    				label: /*label*/ ctx[11],
    				suffix: /*payload*/ ctx[12].quantity,
    				selected: /*$_selectedFilters*/ ctx[1]['features']?.includes(/*label*/ ctx[11]),
    				onClick: func_1
    			}
    		});

    	return {
    		c() {
    			create_component(checkbox.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(checkbox, target, anchor);
    			current = true;
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			const checkbox_changes = {};
    			if (dirty & /*$_featureFilters*/ 4) checkbox_changes.label = /*label*/ ctx[11];
    			if (dirty & /*$_featureFilters*/ 4) checkbox_changes.suffix = /*payload*/ ctx[12].quantity;
    			if (dirty & /*$_selectedFilters, $_featureFilters*/ 6) checkbox_changes.selected = /*$_selectedFilters*/ ctx[1]['features']?.includes(/*label*/ ctx[11]);
    			if (dirty & /*$_featureFilters*/ 4) checkbox_changes.onClick = func_1;
    			checkbox.$set(checkbox_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(checkbox.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(checkbox.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(checkbox, detaching);
    		}
    	};
    }

    // (34:12) {#each Object.entries($_typeFilters) as [label, payload]}
    function create_each_block_1(ctx) {
    	let checkbox;
    	let current;

    	function func_2() {
    		return /*func_2*/ ctx[7](/*label*/ ctx[11]);
    	}

    	checkbox = new Checkbox({
    			props: {
    				label: /*label*/ ctx[11],
    				suffix: /*payload*/ ctx[12].quantity,
    				selected: /*$_selectedFilters*/ ctx[1]['type']?.includes(/*label*/ ctx[11]),
    				onClick: func_2
    			}
    		});

    	return {
    		c() {
    			create_component(checkbox.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(checkbox, target, anchor);
    			current = true;
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			const checkbox_changes = {};
    			if (dirty & /*$_typeFilters*/ 8) checkbox_changes.label = /*label*/ ctx[11];
    			if (dirty & /*$_typeFilters*/ 8) checkbox_changes.suffix = /*payload*/ ctx[12].quantity;
    			if (dirty & /*$_selectedFilters, $_typeFilters*/ 10) checkbox_changes.selected = /*$_selectedFilters*/ ctx[1]['type']?.includes(/*label*/ ctx[11]);
    			if (dirty & /*$_typeFilters*/ 8) checkbox_changes.onClick = func_2;
    			checkbox.$set(checkbox_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(checkbox.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(checkbox.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(checkbox, detaching);
    		}
    	};
    }

    // (44:12) {#each Object.entries($_patternFilters) as [label, payload]}
    function create_each_block$1(ctx) {
    	let checkbox;
    	let current;

    	function func_3() {
    		return /*func_3*/ ctx[8](/*label*/ ctx[11]);
    	}

    	checkbox = new Checkbox({
    			props: {
    				label: /*label*/ ctx[11],
    				suffix: /*payload*/ ctx[12].quantity,
    				selected: /*$_selectedFilters*/ ctx[1]['pattern']?.includes(/*label*/ ctx[11]),
    				onClick: func_3
    			}
    		});

    	return {
    		c() {
    			create_component(checkbox.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(checkbox, target, anchor);
    			current = true;
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			const checkbox_changes = {};
    			if (dirty & /*$_patternFilters*/ 16) checkbox_changes.label = /*label*/ ctx[11];
    			if (dirty & /*$_patternFilters*/ 16) checkbox_changes.suffix = /*payload*/ ctx[12].quantity;
    			if (dirty & /*$_selectedFilters, $_patternFilters*/ 18) checkbox_changes.selected = /*$_selectedFilters*/ ctx[1]['pattern']?.includes(/*label*/ ctx[11]);
    			if (dirty & /*$_patternFilters*/ 16) checkbox_changes.onClick = func_3;
    			checkbox.$set(checkbox_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(checkbox.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(checkbox.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(checkbox, detaching);
    		}
    	};
    }

    // (54:8) <Button onClick={() => FiltersController.apply()}>
    function create_default_slot_1$1(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("Apply filters");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    // (55:8) <Button inline onClick={() => FiltersController.cancel()}>
    function create_default_slot$2(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("Cancel filters");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    function create_fragment$8(ctx) {
    	let div6;
    	let div4;
    	let h30;
    	let t1;
    	let div0;
    	let t2;
    	let h31;
    	let t4;
    	let div1;
    	let t5;
    	let h32;
    	let t7;
    	let div2;
    	let t8;
    	let h33;
    	let t10;
    	let div3;
    	let t11;
    	let div5;
    	let button0;
    	let t12;
    	let button1;
    	let current;
    	let each_value_3 = Object.entries(/*$_colorFilters*/ ctx[0]);
    	let each_blocks_3 = [];

    	for (let i = 0; i < each_value_3.length; i += 1) {
    		each_blocks_3[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
    	}

    	const out = i => transition_out(each_blocks_3[i], 1, 1, () => {
    		each_blocks_3[i] = null;
    	});

    	let each_value_2 = Object.entries(/*$_featureFilters*/ ctx[2]);
    	let each_blocks_2 = [];

    	for (let i = 0; i < each_value_2.length; i += 1) {
    		each_blocks_2[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
    	}

    	const out_1 = i => transition_out(each_blocks_2[i], 1, 1, () => {
    		each_blocks_2[i] = null;
    	});

    	let each_value_1 = Object.entries(/*$_typeFilters*/ ctx[3]);
    	let each_blocks_1 = [];

    	for (let i = 0; i < each_value_1.length; i += 1) {
    		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
    	}

    	const out_2 = i => transition_out(each_blocks_1[i], 1, 1, () => {
    		each_blocks_1[i] = null;
    	});

    	let each_value = Object.entries(/*$_patternFilters*/ ctx[4]);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
    	}

    	const out_3 = i => transition_out(each_blocks[i], 1, 1, () => {
    		each_blocks[i] = null;
    	});

    	button0 = new Button({
    			props: {
    				onClick: /*func_4*/ ctx[9],
    				$$slots: { default: [create_default_slot_1$1] },
    				$$scope: { ctx }
    			}
    		});

    	button1 = new Button({
    			props: {
    				inline: true,
    				onClick: /*func_5*/ ctx[10],
    				$$slots: { default: [create_default_slot$2] },
    				$$scope: { ctx }
    			}
    		});

    	return {
    		c() {
    			div6 = element("div");
    			div4 = element("div");
    			h30 = element("h3");
    			h30.textContent = "Colors";
    			t1 = space();
    			div0 = element("div");

    			for (let i = 0; i < each_blocks_3.length; i += 1) {
    				each_blocks_3[i].c();
    			}

    			t2 = space();
    			h31 = element("h3");
    			h31.textContent = "Features";
    			t4 = space();
    			div1 = element("div");

    			for (let i = 0; i < each_blocks_2.length; i += 1) {
    				each_blocks_2[i].c();
    			}

    			t5 = space();
    			h32 = element("h3");
    			h32.textContent = "Types";
    			t7 = space();
    			div2 = element("div");

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				each_blocks_1[i].c();
    			}

    			t8 = space();
    			h33 = element("h3");
    			h33.textContent = "Pattern";
    			t10 = space();
    			div3 = element("div");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			t11 = space();
    			div5 = element("div");
    			create_component(button0.$$.fragment);
    			t12 = space();
    			create_component(button1.$$.fragment);
    			attr(h30, "class", "FiltersPage__label svelte-1vw6gdb");
    			attr(div0, "class", "FiltersPage__grid svelte-1vw6gdb");
    			attr(h31, "class", "FiltersPage__label svelte-1vw6gdb");
    			attr(div1, "class", "FiltersPage__grid svelte-1vw6gdb");
    			attr(h32, "class", "FiltersPage__label svelte-1vw6gdb");
    			attr(div2, "class", "FiltersPage__grid svelte-1vw6gdb");
    			attr(h33, "class", "FiltersPage__label svelte-1vw6gdb");
    			attr(div3, "class", "FiltersPage__grid svelte-1vw6gdb");
    			attr(div4, "class", "FiltersPage__body svelte-1vw6gdb");
    			attr(div5, "class", "FiltersPage__footer");
    			attr(div6, "class", "FiltersPage svelte-1vw6gdb");
    		},
    		m(target, anchor) {
    			insert(target, div6, anchor);
    			append(div6, div4);
    			append(div4, h30);
    			append(div4, t1);
    			append(div4, div0);

    			for (let i = 0; i < each_blocks_3.length; i += 1) {
    				if (each_blocks_3[i]) {
    					each_blocks_3[i].m(div0, null);
    				}
    			}

    			append(div4, t2);
    			append(div4, h31);
    			append(div4, t4);
    			append(div4, div1);

    			for (let i = 0; i < each_blocks_2.length; i += 1) {
    				if (each_blocks_2[i]) {
    					each_blocks_2[i].m(div1, null);
    				}
    			}

    			append(div4, t5);
    			append(div4, h32);
    			append(div4, t7);
    			append(div4, div2);

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				if (each_blocks_1[i]) {
    					each_blocks_1[i].m(div2, null);
    				}
    			}

    			append(div4, t8);
    			append(div4, h33);
    			append(div4, t10);
    			append(div4, div3);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				if (each_blocks[i]) {
    					each_blocks[i].m(div3, null);
    				}
    			}

    			append(div6, t11);
    			append(div6, div5);
    			mount_component(button0, div5, null);
    			append(div5, t12);
    			mount_component(button1, div5, null);
    			current = true;
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*Object, $_colorFilters, $_selectedFilters, FiltersController*/ 3) {
    				each_value_3 = Object.entries(/*$_colorFilters*/ ctx[0]);
    				let i;

    				for (i = 0; i < each_value_3.length; i += 1) {
    					const child_ctx = get_each_context_3(ctx, each_value_3, i);

    					if (each_blocks_3[i]) {
    						each_blocks_3[i].p(child_ctx, dirty);
    						transition_in(each_blocks_3[i], 1);
    					} else {
    						each_blocks_3[i] = create_each_block_3(child_ctx);
    						each_blocks_3[i].c();
    						transition_in(each_blocks_3[i], 1);
    						each_blocks_3[i].m(div0, null);
    					}
    				}

    				group_outros();

    				for (i = each_value_3.length; i < each_blocks_3.length; i += 1) {
    					out(i);
    				}

    				check_outros();
    			}

    			if (dirty & /*Object, $_featureFilters, $_selectedFilters, FiltersController*/ 6) {
    				each_value_2 = Object.entries(/*$_featureFilters*/ ctx[2]);
    				let i;

    				for (i = 0; i < each_value_2.length; i += 1) {
    					const child_ctx = get_each_context_2(ctx, each_value_2, i);

    					if (each_blocks_2[i]) {
    						each_blocks_2[i].p(child_ctx, dirty);
    						transition_in(each_blocks_2[i], 1);
    					} else {
    						each_blocks_2[i] = create_each_block_2(child_ctx);
    						each_blocks_2[i].c();
    						transition_in(each_blocks_2[i], 1);
    						each_blocks_2[i].m(div1, null);
    					}
    				}

    				group_outros();

    				for (i = each_value_2.length; i < each_blocks_2.length; i += 1) {
    					out_1(i);
    				}

    				check_outros();
    			}

    			if (dirty & /*Object, $_typeFilters, $_selectedFilters, FiltersController*/ 10) {
    				each_value_1 = Object.entries(/*$_typeFilters*/ ctx[3]);
    				let i;

    				for (i = 0; i < each_value_1.length; i += 1) {
    					const child_ctx = get_each_context_1(ctx, each_value_1, i);

    					if (each_blocks_1[i]) {
    						each_blocks_1[i].p(child_ctx, dirty);
    						transition_in(each_blocks_1[i], 1);
    					} else {
    						each_blocks_1[i] = create_each_block_1(child_ctx);
    						each_blocks_1[i].c();
    						transition_in(each_blocks_1[i], 1);
    						each_blocks_1[i].m(div2, null);
    					}
    				}

    				group_outros();

    				for (i = each_value_1.length; i < each_blocks_1.length; i += 1) {
    					out_2(i);
    				}

    				check_outros();
    			}

    			if (dirty & /*Object, $_patternFilters, $_selectedFilters, FiltersController*/ 18) {
    				each_value = Object.entries(/*$_patternFilters*/ ctx[4]);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$1(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    						transition_in(each_blocks[i], 1);
    					} else {
    						each_blocks[i] = create_each_block$1(child_ctx);
    						each_blocks[i].c();
    						transition_in(each_blocks[i], 1);
    						each_blocks[i].m(div3, null);
    					}
    				}

    				group_outros();

    				for (i = each_value.length; i < each_blocks.length; i += 1) {
    					out_3(i);
    				}

    				check_outros();
    			}

    			const button0_changes = {};

    			if (dirty & /*$$scope*/ 2097152) {
    				button0_changes.$$scope = { dirty, ctx };
    			}

    			button0.$set(button0_changes);
    			const button1_changes = {};

    			if (dirty & /*$$scope*/ 2097152) {
    				button1_changes.$$scope = { dirty, ctx };
    			}

    			button1.$set(button1_changes);
    		},
    		i(local) {
    			if (current) return;

    			for (let i = 0; i < each_value_3.length; i += 1) {
    				transition_in(each_blocks_3[i]);
    			}

    			for (let i = 0; i < each_value_2.length; i += 1) {
    				transition_in(each_blocks_2[i]);
    			}

    			for (let i = 0; i < each_value_1.length; i += 1) {
    				transition_in(each_blocks_1[i]);
    			}

    			for (let i = 0; i < each_value.length; i += 1) {
    				transition_in(each_blocks[i]);
    			}

    			transition_in(button0.$$.fragment, local);
    			transition_in(button1.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			each_blocks_3 = each_blocks_3.filter(Boolean);

    			for (let i = 0; i < each_blocks_3.length; i += 1) {
    				transition_out(each_blocks_3[i]);
    			}

    			each_blocks_2 = each_blocks_2.filter(Boolean);

    			for (let i = 0; i < each_blocks_2.length; i += 1) {
    				transition_out(each_blocks_2[i]);
    			}

    			each_blocks_1 = each_blocks_1.filter(Boolean);

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				transition_out(each_blocks_1[i]);
    			}

    			each_blocks = each_blocks.filter(Boolean);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				transition_out(each_blocks[i]);
    			}

    			transition_out(button0.$$.fragment, local);
    			transition_out(button1.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div6);
    			destroy_each(each_blocks_3, detaching);
    			destroy_each(each_blocks_2, detaching);
    			destroy_each(each_blocks_1, detaching);
    			destroy_each(each_blocks, detaching);
    			destroy_component(button0);
    			destroy_component(button1);
    		}
    	};
    }

    function instance$8($$self, $$props, $$invalidate) {
    	let $_colorFilters;
    	let $_selectedFilters;
    	let $_featureFilters;
    	let $_typeFilters;
    	let $_patternFilters;
    	component_subscribe($$self, _colorFilters, $$value => $$invalidate(0, $_colorFilters = $$value));
    	component_subscribe($$self, _selectedFilters, $$value => $$invalidate(1, $_selectedFilters = $$value));
    	component_subscribe($$self, _featureFilters, $$value => $$invalidate(2, $_featureFilters = $$value));
    	component_subscribe($$self, _typeFilters, $$value => $$invalidate(3, $_typeFilters = $$value));
    	component_subscribe($$self, _patternFilters, $$value => $$invalidate(4, $_patternFilters = $$value));
    	const func = label => FiltersController$1.select('color', label);
    	const func_1 = label => FiltersController$1.select('features', label);
    	const func_2 = label => FiltersController$1.select('type', label);
    	const func_3 = label => FiltersController$1.select('pattern', label);
    	const func_4 = () => FiltersController$1.apply();
    	const func_5 = () => FiltersController$1.cancel();

    	return [
    		$_colorFilters,
    		$_selectedFilters,
    		$_featureFilters,
    		$_typeFilters,
    		$_patternFilters,
    		func,
    		func_1,
    		func_2,
    		func_3,
    		func_4,
    		func_5
    	];
    }

    class FiltersPage extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$8, create_fragment$8, safe_not_equal, {}, add_css$7);
    	}
    }

    function makeId(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    /* src/components/FormInput.svelte generated by Svelte v3.59.2 */

    function add_css$6(target) {
    	append_styles(target, "svelte-g5teh5", ".FormInput.svelte-g5teh5{display:flex;flex-direction:column}.FormInput__label.svelte-g5teh5{margin-bottom:5px;font-size:15px}.FormInput__label.svelte-g5teh5:empty{display:none}.FormInput__input.svelte-g5teh5{font-size:15px;min-height:46px;-webkit-appearance:none;-webkit-border-radius:0;display:block;width:100%;height:40px;padding:12px 15px;letter-spacing:0.5px;border:1px solid #edece8}.FormInput__other.svelte-g5teh5{margin-top:10px}.FormInput__other.svelte-g5teh5:empty{display:none}");
    }

    function create_fragment$7(ctx) {
    	let div1;
    	let label_1;
    	let t0;
    	let t1;
    	let input;
    	let t2;
    	let div0;
    	let current;
    	let mounted;
    	let dispose;
    	const default_slot_template = /*#slots*/ ctx[6].default;
    	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[5], null);

    	return {
    		c() {
    			div1 = element("div");
    			label_1 = element("label");
    			t0 = text(/*label*/ ctx[2]);
    			t1 = space();
    			input = element("input");
    			t2 = space();
    			div0 = element("div");
    			if (default_slot) default_slot.c();
    			attr(label_1, "for", /*id*/ ctx[3]);
    			attr(label_1, "class", "FormInput__label svelte-g5teh5");
    			attr(input, "id", /*id*/ ctx[3]);
    			attr(input, "type", "text");
    			attr(input, "class", "FormInput__input svelte-g5teh5");
    			input.disabled = /*disabled*/ ctx[1];
    			attr(div0, "class", "FormInput__other svelte-g5teh5");
    			attr(div1, "class", "FormInput svelte-g5teh5");
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, label_1);
    			append(label_1, t0);
    			append(div1, t1);
    			append(div1, input);
    			set_input_value(input, /*value*/ ctx[0]);
    			append(div1, t2);
    			append(div1, div0);

    			if (default_slot) {
    				default_slot.m(div0, null);
    			}

    			current = true;

    			if (!mounted) {
    				dispose = listen(input, "input", /*input_input_handler*/ ctx[7]);
    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			if (!current || dirty & /*label*/ 4) set_data(t0, /*label*/ ctx[2]);

    			if (!current || dirty & /*disabled*/ 2) {
    				input.disabled = /*disabled*/ ctx[1];
    			}

    			if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
    				set_input_value(input, /*value*/ ctx[0]);
    			}

    			if (default_slot) {
    				if (default_slot.p && (!current || dirty & /*$$scope*/ 32)) {
    					update_slot_base(
    						default_slot,
    						default_slot_template,
    						ctx,
    						/*$$scope*/ ctx[5],
    						!current
    						? get_all_dirty_from_scope(/*$$scope*/ ctx[5])
    						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[5], dirty, null),
    						null
    					);
    				}
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(default_slot, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(default_slot, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div1);
    			if (default_slot) default_slot.d(detaching);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$7($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	let { disabled = false } = $$props;
    	let { type = 'text' } = $$props;
    	let { label } = $$props;
    	let { value } = $$props;
    	const id = makeId(6);

    	function input_input_handler() {
    		value = this.value;
    		$$invalidate(0, value);
    	}

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(1, disabled = $$props.disabled);
    		if ('type' in $$props) $$invalidate(4, type = $$props.type);
    		if ('label' in $$props) $$invalidate(2, label = $$props.label);
    		if ('value' in $$props) $$invalidate(0, value = $$props.value);
    		if ('$$scope' in $$props) $$invalidate(5, $$scope = $$props.$$scope);
    	};

    	return [value, disabled, label, id, type, $$scope, slots, input_input_handler];
    }

    class FormInput extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$7, create_fragment$7, safe_not_equal, { disabled: 1, type: 4, label: 2, value: 0 }, add_css$6);
    	}
    }

    /* src/components/FormSelect.svelte generated by Svelte v3.59.2 */

    function add_css$5(target) {
    	append_styles(target, "svelte-60fa4x", ".FormSelect.svelte-60fa4x{display:flex;flex-direction:column}.FormSelect__label.svelte-60fa4x{margin-bottom:5px;font-size:15px}.FormSelect__label.svelte-60fa4x:empty{display:none}.FormSelect__input.svelte-60fa4x{font-size:15px;min-height:46px;-webkit-appearance:none;-webkit-border-radius:0;display:block;width:100%;height:40px;padding:12px 15px;letter-spacing:0.5px;border:1px solid #edece8}.FormSelect__other.svelte-60fa4x{margin-top:10px}.FormSelect__other.svelte-60fa4x:empty{display:none}");
    }

    function get_each_context(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[9] = list[i][0];
    	child_ctx[2] = list[i][1];
    	return child_ctx;
    }

    // (14:8) {#each Object.entries(options) as [v, label]}
    function create_each_block(ctx) {
    	let option;
    	let t_value = /*label*/ ctx[2] + "";
    	let t;
    	let option_value_value;
    	let option_selected_value;

    	return {
    		c() {
    			option = element("option");
    			t = text(t_value);
    			option.__value = option_value_value = /*v*/ ctx[9];
    			option.value = option.__value;
    			option.selected = option_selected_value = /*v*/ ctx[9] === /*value*/ ctx[0];
    		},
    		m(target, anchor) {
    			insert(target, option, anchor);
    			append(option, t);
    		},
    		p(ctx, dirty) {
    			if (dirty & /*options*/ 2 && t_value !== (t_value = /*label*/ ctx[2] + "")) set_data(t, t_value);

    			if (dirty & /*options*/ 2 && option_value_value !== (option_value_value = /*v*/ ctx[9])) {
    				option.__value = option_value_value;
    				option.value = option.__value;
    			}

    			if (dirty & /*options, value, Object*/ 3 && option_selected_value !== (option_selected_value = /*v*/ ctx[9] === /*value*/ ctx[0])) {
    				option.selected = option_selected_value;
    			}
    		},
    		d(detaching) {
    			if (detaching) detach(option);
    		}
    	};
    }

    function create_fragment$6(ctx) {
    	let div1;
    	let label_1;
    	let t0;
    	let t1;
    	let select;
    	let option;
    	let t2;
    	let option_selected_value;
    	let t3;
    	let div0;
    	let current;
    	let mounted;
    	let dispose;
    	let each_value = Object.entries(/*options*/ ctx[1]);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
    	}

    	const default_slot_template = /*#slots*/ ctx[7].default;
    	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[6], null);

    	return {
    		c() {
    			div1 = element("div");
    			label_1 = element("label");
    			t0 = text(/*label*/ ctx[2]);
    			t1 = space();
    			select = element("select");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			option = element("option");
    			t2 = text("Please select:");
    			t3 = space();
    			div0 = element("div");
    			if (default_slot) default_slot.c();
    			attr(label_1, "for", /*id*/ ctx[3]);
    			attr(label_1, "class", "FormSelect__label svelte-60fa4x");
    			option.selected = option_selected_value = !/*value*/ ctx[0];
    			option.__value = "Please select:";
    			option.value = option.__value;
    			attr(select, "id", /*id*/ ctx[3]);
    			attr(select, "class", "FormSelect__input svelte-60fa4x");
    			if (/*value*/ ctx[0] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[8].call(select));
    			attr(div0, "class", "FormSelect__other svelte-60fa4x");
    			attr(div1, "class", "FormSelect svelte-60fa4x");
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, label_1);
    			append(label_1, t0);
    			append(div1, t1);
    			append(div1, select);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				if (each_blocks[i]) {
    					each_blocks[i].m(select, null);
    				}
    			}

    			append(select, option);
    			append(option, t2);
    			select_option(select, /*value*/ ctx[0], true);
    			append(div1, t3);
    			append(div1, div0);

    			if (default_slot) {
    				default_slot.m(div0, null);
    			}

    			current = true;

    			if (!mounted) {
    				dispose = listen(select, "change", /*select_change_handler*/ ctx[8]);
    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			if (!current || dirty & /*label*/ 4) set_data(t0, /*label*/ ctx[2]);

    			if (dirty & /*Object, options, value*/ 3) {
    				each_value = Object.entries(/*options*/ ctx[1]);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(select, option);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}

    			if (!current || dirty & /*value, Object, options*/ 3 && option_selected_value !== (option_selected_value = !/*value*/ ctx[0])) {
    				option.selected = option_selected_value;
    			}

    			if (dirty & /*value, Object, options*/ 3) {
    				select_option(select, /*value*/ ctx[0]);
    			}

    			if (default_slot) {
    				if (default_slot.p && (!current || dirty & /*$$scope*/ 64)) {
    					update_slot_base(
    						default_slot,
    						default_slot_template,
    						ctx,
    						/*$$scope*/ ctx[6],
    						!current
    						? get_all_dirty_from_scope(/*$$scope*/ ctx[6])
    						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[6], dirty, null),
    						null
    					);
    				}
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(default_slot, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(default_slot, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div1);
    			destroy_each(each_blocks, detaching);
    			if (default_slot) default_slot.d(detaching);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$6($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	let { disabled = false } = $$props;
    	let { type = 'text' } = $$props;
    	let { label } = $$props;
    	let { value } = $$props;
    	let { options } = $$props;
    	const id = makeId(6);

    	function select_change_handler() {
    		value = select_value(this);
    		$$invalidate(0, value);
    		$$invalidate(1, options);
    	}

    	$$self.$$set = $$props => {
    		if ('disabled' in $$props) $$invalidate(4, disabled = $$props.disabled);
    		if ('type' in $$props) $$invalidate(5, type = $$props.type);
    		if ('label' in $$props) $$invalidate(2, label = $$props.label);
    		if ('value' in $$props) $$invalidate(0, value = $$props.value);
    		if ('options' in $$props) $$invalidate(1, options = $$props.options);
    		if ('$$scope' in $$props) $$invalidate(6, $$scope = $$props.$$scope);
    	};

    	return [
    		value,
    		options,
    		label,
    		id,
    		disabled,
    		type,
    		$$scope,
    		slots,
    		select_change_handler
    	];
    }

    class FormSelect extends SvelteComponent {
    	constructor(options) {
    		super();

    		init(
    			this,
    			options,
    			instance$6,
    			create_fragment$6,
    			safe_not_equal,
    			{
    				disabled: 4,
    				type: 5,
    				label: 2,
    				value: 0,
    				options: 1
    			},
    			add_css$5
    		);
    	}
    }

    const STATES = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        DC: "District of Columbia",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming"
    };

    /**
     * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
     */

    function Cache(maxSize) {
      this._maxSize = maxSize;
      this.clear();
    }
    Cache.prototype.clear = function () {
      this._size = 0;
      this._values = Object.create(null);
    };
    Cache.prototype.get = function (key) {
      return this._values[key]
    };
    Cache.prototype.set = function (key, value) {
      this._size >= this._maxSize && this.clear();
      if (!(key in this._values)) this._size++;

      return (this._values[key] = value)
    };

    var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
      DIGIT_REGEX = /^\d+$/,
      LEAD_DIGIT_REGEX = /^\d/,
      SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
      CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
      MAX_CACHE_SIZE = 512;

    var pathCache = new Cache(MAX_CACHE_SIZE),
      setCache = new Cache(MAX_CACHE_SIZE),
      getCache = new Cache(MAX_CACHE_SIZE);

    var propertyExpr = {
      Cache: Cache,

      split: split,

      normalizePath: normalizePath,

      setter: function (path) {
        var parts = normalizePath(path);

        return (
          setCache.get(path) ||
          setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;

            while (index < len - 1) {
              var part = parts[index];
              if (
                part === '__proto__' ||
                part === 'constructor' ||
                part === 'prototype'
              ) {
                return obj
              }

              data = data[parts[index++]];
            }
            data[parts[index]] = value;
          })
        )
      },

      getter: function (path, safe) {
        var parts = normalizePath(path);
        return (
          getCache.get(path) ||
          getCache.set(path, function getter(data) {
            var index = 0,
              len = parts.length;
            while (index < len) {
              if (data != null || !safe) data = data[parts[index++]];
              else return
            }
            return data
          })
        )
      },

      join: function (segments) {
        return segments.reduce(function (path, part) {
          return (
            path +
            (isQuoted(part) || DIGIT_REGEX.test(part)
              ? '[' + part + ']'
              : (path ? '.' : '') + part)
          )
        }, '')
      },

      forEach: function (path, cb, thisArg) {
        forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
      },
    };

    function normalizePath(path) {
      return (
        pathCache.get(path) ||
        pathCache.set(
          path,
          split(path).map(function (part) {
            return part.replace(CLEAN_QUOTES_REGEX, '$2')
          })
        )
      )
    }

    function split(path) {
      return path.match(SPLIT_REGEX) || ['']
    }

    function forEach(parts, iter, thisArg) {
      var len = parts.length,
        part,
        idx,
        isArray,
        isBracket;

      for (idx = 0; idx < len; idx++) {
        part = parts[idx];

        if (part) {
          if (shouldBeQuoted(part)) {
            part = '"' + part + '"';
          }

          isBracket = isQuoted(part);
          isArray = !isBracket && /^\d+$/.test(part);

          iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
      }
    }

    function isQuoted(str) {
      return (
        typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
      )
    }

    function hasLeadingNumber(part) {
      return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
    }

    function hasSpecialChars(part) {
      return SPEC_CHAR_REGEX.test(part)
    }

    function shouldBeQuoted(part) {
      return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
    }

    const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;

    const words = (str) => str.match(reWords) || [];

    const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);

    const join = (str, d) => words(str).join(d).toLowerCase();

    const camelCase = (str) =>
      words(str).reduce(
        (acc, next) =>
          `${acc}${
        !acc
          ? next.toLowerCase()
          : next[0].toUpperCase() + next.slice(1).toLowerCase()
      }`,
        '',
      );

    const pascalCase = (str) => upperFirst(camelCase(str));

    const snakeCase = (str) => join(str, '_');

    const kebabCase = (str) => join(str, '-');

    const sentenceCase = (str) => upperFirst(join(str, ' '));

    const titleCase = (str) => words(str).map(upperFirst).join(' ');

    var tinyCase = {
      words,
      upperFirst,
      camelCase,
      pascalCase,
      snakeCase,
      kebabCase,
      sentenceCase,
      titleCase,
    };

    /**
     * Topological sorting function
     *
     * @param {Array} edges
     * @returns {Array}
     */

    var toposort_1 = function(edges) {
      return toposort(uniqueNodes(edges), edges)
    };

    var array$1 = toposort;

    function toposort(nodes, edges) {
      var cursor = nodes.length
        , sorted = new Array(cursor)
        , visited = {}
        , i = cursor
        // Better data structures make algorithm much faster.
        , outgoingEdges = makeOutgoingEdges(edges)
        , nodesHash = makeNodesHash(nodes);

      // check for unknown nodes
      edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
          throw new Error('Unknown node. There is an unknown node in the supplied edges.')
        }
      });

      while (i--) {
        if (!visited[i]) visit(nodes[i], i, new Set());
      }

      return sorted

      function visit(node, i, predecessors) {
        if(predecessors.has(node)) {
          var nodeRep;
          try {
            nodeRep = ", node was:" + JSON.stringify(node);
          } catch(e) {
            nodeRep = "";
          }
          throw new Error('Cyclic dependency' + nodeRep)
        }

        if (!nodesHash.has(node)) {
          throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
        }

        if (visited[i]) return;
        visited[i] = true;

        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);

        if (i = outgoing.length) {
          predecessors.add(node);
          do {
            var child = outgoing[--i];
            visit(child, nodesHash.get(child), predecessors);
          } while (i)
          predecessors.delete(node);
        }

        sorted[--cursor] = node;
      }
    }

    function uniqueNodes(arr){
      var res = new Set();
      for (var i = 0, len = arr.length; i < len; i++) {
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
      }
      return Array.from(res)
    }

    function makeOutgoingEdges(arr){
      var edges = new Map();
      for (var i = 0, len = arr.length; i < len; i++) {
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
      }
      return edges
    }

    function makeNodesHash(arr){
      var res = new Map();
      for (var i = 0, len = arr.length; i < len; i++) {
        res.set(arr[i], i);
      }
      return res
    }
    toposort_1.array = array$1;

    const toString = Object.prototype.toString;
    const errorToString = Error.prototype.toString;
    const regExpToString = RegExp.prototype.toString;
    const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
    const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
    function printNumber(val) {
      if (val != +val) return 'NaN';
      const isNegativeZero = val === 0 && 1 / val < 0;
      return isNegativeZero ? '-0' : '' + val;
    }
    function printSimpleValue(val, quoteStrings = false) {
      if (val == null || val === true || val === false) return '' + val;
      const typeOf = typeof val;
      if (typeOf === 'number') return printNumber(val);
      if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
      if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
      if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
      const tag = toString.call(val).slice(8, -1);
      if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
      if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
      if (tag === 'RegExp') return regExpToString.call(val);
      return null;
    }
    function printValue(value, quoteStrings) {
      let result = printSimpleValue(value, quoteStrings);
      if (result !== null) return result;
      return JSON.stringify(value, function (key, value) {
        let result = printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
      }, 2);
    }

    function toArray(value) {
      return value == null ? [] : [].concat(value);
    }

    let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
    let strReg = /\$\{\s*(\w+)\s*\}/g;
    _Symbol$toStringTag = Symbol.toStringTag;
    class ValidationErrorNoStack {
      constructor(errorOrErrors, value, field, type) {
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        toArray(errorOrErrors).forEach(err => {
          if (ValidationError.isError(err)) {
            this.errors.push(...err.errors);
            const innerErrors = err.inner.length ? err.inner : [err];
            this.inner.push(...innerErrors);
          } else {
            this.errors.push(err);
          }
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
      }
    }
    _Symbol$hasInstance = Symbol.hasInstance;
    _Symbol$toStringTag2 = Symbol.toStringTag;
    class ValidationError extends Error {
      static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = Object.assign({}, params, {
          path
        });
        if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
      }
      static isError(err) {
        return err && err.name === 'ValidationError';
      }
      constructor(errorOrErrors, value, field, type, disableStack) {
        const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) {
          return errorNoStack;
        }
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, ValidationError);
        }
      }
      static [_Symbol$hasInstance](inst) {
        return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
      }
    }

    let mixed = {
      default: '${path} is invalid',
      required: '${path} is a required field',
      defined: '${path} must be defined',
      notNull: '${path} cannot be null',
      oneOf: '${path} must be one of the following values: ${values}',
      notOneOf: '${path} must not be one of the following values: ${values}',
      notType: ({
        path,
        type,
        value,
        originalValue
      }) => {
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
      }
    };
    let string = {
      length: '${path} must be exactly ${length} characters',
      min: '${path} must be at least ${min} characters',
      max: '${path} must be at most ${max} characters',
      matches: '${path} must match the following: "${regex}"',
      email: '${path} must be a valid email',
      url: '${path} must be a valid URL',
      uuid: '${path} must be a valid UUID',
      datetime: '${path} must be a valid ISO date-time',
      datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
      datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
      trim: '${path} must be a trimmed string',
      lowercase: '${path} must be a lowercase string',
      uppercase: '${path} must be a upper case string'
    };
    let number = {
      min: '${path} must be greater than or equal to ${min}',
      max: '${path} must be less than or equal to ${max}',
      lessThan: '${path} must be less than ${less}',
      moreThan: '${path} must be greater than ${more}',
      positive: '${path} must be a positive number',
      negative: '${path} must be a negative number',
      integer: '${path} must be an integer'
    };
    let date = {
      min: '${path} field must be later than ${min}',
      max: '${path} field must be at earlier than ${max}'
    };
    let boolean = {
      isValue: '${path} field must be ${value}'
    };
    let object = {
      noUnknown: '${path} field has unspecified keys: ${unknown}'
    };
    let array = {
      min: '${path} field must have at least ${min} items',
      max: '${path} field must have less than or equal to ${max} items',
      length: '${path} must have ${length} items'
    };
    let tuple = {
      notType: params => {
        const {
          path,
          value,
          spec
        } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
          if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
          if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
        }
        return ValidationError.formatError(mixed.notType, params);
      }
    };
    Object.assign(Object.create(null), {
      mixed,
      string,
      number,
      date,
      object,
      array,
      boolean,
      tuple
    });

    const isSchema = obj => obj && obj.__isYupSchema__;

    class Condition {
      static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let {
          is,
          then,
          otherwise
        } = config;
        let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
        return new Condition(refs, (values, schema) => {
          var _branch;
          let branch = check(...values) ? then : otherwise;
          return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
      }
      constructor(refs, builder) {
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
      }
      resolve(base, options) {
        let values = this.refs.map(ref =>
        // TODO: ? operator here?
        ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined ||
        // @ts-ignore this can be base
        schema === base) {
          return base;
        }
        if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
      }
    }

    const prefixes = {
      context: '$',
      value: '.'
    };
    class Reference {
      constructor(key, options = {}) {
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === prefixes.context;
        this.isValue = this.key[0] === prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && propertyExpr.getter(this.path, true);
        this.map = options.map;
      }
      getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
      }

      /**
       *
       * @param {*} value
       * @param {Object} options
       * @param {Object=} options.context
       * @param {Object=} options.parent
       */
      cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
      }
      resolve() {
        return this;
      }
      describe() {
        return {
          type: 'ref',
          key: this.key
        };
      }
      toString() {
        return `Ref(${this.key})`;
      }
      static isRef(value) {
        return value && value.__isYupRef;
      }
    }

    // @ts-ignore
    Reference.prototype.__isYupRef = true;

    const isAbsent = value => value == null;

    function createValidation(config) {
      function validate({
        value,
        path = '',
        options,
        originalValue,
        schema
      }, panic, next) {
        const {
          name,
          test,
          params,
          message,
          skipAbsent
        } = config;
        let {
          parent,
          context,
          abortEarly = schema.spec.abortEarly,
          disableStackTrace = schema.spec.disableStackTrace
        } = options;
        function resolve(item) {
          return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
          const nextParams = Object.assign({
            value,
            originalValue,
            label: schema.spec.label,
            path: overrides.path || path,
            spec: schema.spec,
            disableStackTrace: overrides.disableStackTrace || disableStackTrace
          }, params, overrides.params);
          for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
          const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
          error.params = nextParams;
          return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
          path,
          parent,
          type: name,
          from: options.from,
          createError,
          resolve,
          options,
          originalValue,
          schema
        };
        const handleResult = validOrError => {
          if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
        };
        const handleError = err => {
          if (ValidationError.isError(err)) invalid(err);else panic(err);
        };
        const shouldSkip = skipAbsent && isAbsent(value);
        if (shouldSkip) {
          return handleResult(true);
        }
        let result;
        try {
          var _result;
          result = test.call(ctx, value, ctx);
          if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
            if (options.sync) {
              throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
            }
            return Promise.resolve(result).then(handleResult, handleError);
          }
        } catch (err) {
          handleError(err);
          return;
        }
        handleResult(result);
      }
      validate.OPTIONS = config;
      return validate;
    }

    function getIn(schema, path, value, context = value) {
      let parent, lastPart, lastPartDebug;

      // root path: ''
      if (!path) return {
        parent,
        parentPath: path,
        schema
      };
      propertyExpr.forEach(path, (_part, isBracket, isArray) => {
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
          context,
          parent,
          value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
          if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
          if (value && idx >= value.length) {
            throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
          }
          parent = value;
          value = value && value[idx];
          schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }

        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
          if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
          parent = value;
          value = value && value[part];
          schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
      });
      return {
        schema,
        parent,
        parentPath: lastPart
      };
    }

    class ReferenceSet extends Set {
      describe() {
        const description = [];
        for (const item of this.values()) {
          description.push(Reference.isRef(item) ? item.describe() : item);
        }
        return description;
      }
      resolveAll(resolve) {
        let result = [];
        for (const item of this.values()) {
          result.push(resolve(item));
        }
        return result;
      }
      clone() {
        return new ReferenceSet(this.values());
      }
      merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach(value => next.add(value));
        removeItems.forEach(value => next.delete(value));
        return next;
      }
    }

    // tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
    function clone(src, seen = new Map()) {
      if (isSchema(src) || !src || typeof src !== 'object') return src;
      if (seen.has(src)) return seen.get(src);
      let copy;
      if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
      } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
      } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
      } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
      } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src) copy.add(clone(v, seen));
      } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
      } else {
        throw Error(`Unable to clone ${src}`);
      }
      return copy;
    }

    // If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
    // loose Record definition allowing free form usage.
    class Schema {
      constructor(options) {
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new ReferenceSet();
        this._blacklist = new ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(() => {
          this.typeError(mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
          strip: false,
          strict: false,
          abortEarly: true,
          recursive: true,
          disableStackTrace: false,
          nullable: false,
          optional: true,
          coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation(s => {
          s.nonNullable();
        });
      }

      // TODO: remove
      get _type() {
        return this.type;
      }
      clone(spec) {
        if (this._mutate) {
          if (spec) Object.assign(this.spec, spec);
          return this;
        }

        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));

        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);

        // @ts-expect-error this is readonly
        next.deps = [...this.deps];
        next.conditions = [...this.conditions];
        next.tests = [...this.tests];
        next.transforms = [...this.transforms];
        next.spec = clone(Object.assign({}, this.spec, spec));
        return next;
      }
      label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
      }
      meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
      }
      withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
      }
      concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;

        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation(next => {
          schema.tests.forEach(fn => {
            next.test(fn.OPTIONS);
          });
        });
        combined.transforms = [...base.transforms, ...combined.transforms];
        return combined;
      }
      isType(v) {
        if (v == null) {
          if (this.spec.nullable && v === null) return true;
          if (this.spec.optional && v === undefined) return true;
          return false;
        }
        return this._typeCheck(v);
      }
      resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
          let conditions = schema.conditions;
          schema = schema.clone();
          schema.conditions = [];
          schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
          schema = schema.resolve(options);
        }
        return schema;
      }
      resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
          from: options.from || [],
          strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
          abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
          recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
          disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
      }

      /**
       * Run the configured transform pipeline over an input value.
       */

      cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
          value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
          if (allowOptionality && isAbsent(result)) {
            return result;
          }
          let formattedValue = printValue(value);
          let formattedResult = printValue(result);
          throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
      }
      _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) {
          value = this.getDefault(options);
        }
        return value;
      }
      _validate(_value, options = {}, panic, next) {
        let {
          path,
          originalValue = _value,
          strict = this.spec.strict
        } = options;
        let value = _value;
        if (!strict) {
          value = this._cast(value, Object.assign({
            assert: false
          }, options));
        }
        let initialTests = [];
        for (let test of Object.values(this.internalTests)) {
          if (test) initialTests.push(test);
        }
        this.runTests({
          path,
          value,
          originalValue,
          options,
          tests: initialTests
        }, panic, initialErrors => {
          // even if we aren't ending early we can't proceed further if the types aren't correct
          if (initialErrors.length) {
            return next(initialErrors, value);
          }
          this.runTests({
            path,
            value,
            originalValue,
            options,
            tests: this.tests
          }, panic, next);
        });
      }

      /**
       * Executes a set of validations, either schema, produced Tests or a nested
       * schema validate result.
       */
      runTests(runOptions, panic, next) {
        let fired = false;
        let {
          tests,
          value,
          originalValue,
          path,
          options
        } = runOptions;
        let panicOnce = arg => {
          if (fired) return;
          fired = true;
          panic(arg, value);
        };
        let nextOnce = arg => {
          if (fired) return;
          fired = true;
          next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
          value,
          originalValue,
          path,
          options,
          schema: this
        };
        for (let i = 0; i < tests.length; i++) {
          const test = tests[i];
          test(args, panicOnce, function finishTestRun(err) {
            if (err) {
              Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
            }
            if (--count <= 0) {
              nextOnce(nestedErrors);
            }
          });
        }
      }
      asNestedTest({
        key,
        index,
        parent,
        parentPath,
        originalParent,
        options
      }) {
        const k = key != null ? key : index;
        if (k == null) {
          throw TypeError('Must include `key` or `index` for nested validations');
        }
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
          // Nested validations fields are always strict:
          //    1. parent isn't strict so the casting will also have cast inner values
          //    2. parent is strict in which case the nested values weren't cast either
          strict: true,
          parent,
          value,
          originalValue: originalParent[k],
          // FIXME: tests depend on `index` being passed around deeply,
          //   we should not let the options.key/index bleed through
          key: undefined,
          // index: undefined,
          [isIndex ? 'index' : 'key']: k,
          path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
      }
      validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
          value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
          if (ValidationError.isError(error)) error.value = parsed;
          reject(error);
        }, (errors, validated) => {
          if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
        }));
      }
      validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
          value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
          sync: true
        }), (error, parsed) => {
          if (ValidationError.isError(error)) error.value = parsed;
          throw error;
        }, (errors, validated) => {
          if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
          result = validated;
        });
        return result;
      }
      isValid(value, options) {
        return this.validate(value, options).then(() => true, err => {
          if (ValidationError.isError(err)) return false;
          throw err;
        });
      }
      isValidSync(value, options) {
        try {
          this.validateSync(value, options);
          return true;
        } catch (err) {
          if (ValidationError.isError(err)) return false;
          throw err;
        }
      }
      _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) {
          return defaultValue;
        }
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
      }
      getDefault(options
      // If schema is defaulted we know it's at least not undefined
      ) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
      }
      default(def) {
        if (arguments.length === 0) {
          return this._getDefault();
        }
        let next = this.clone({
          default: def
        });
        return next;
      }
      strict(isStrict = true) {
        return this.clone({
          strict: isStrict
        });
      }
      nullability(nullable, message) {
        const next = this.clone({
          nullable
        });
        next.internalTests.nullable = createValidation({
          message,
          name: 'nullable',
          test(value) {
            return value === null ? this.schema.spec.nullable : true;
          }
        });
        return next;
      }
      optionality(optional, message) {
        const next = this.clone({
          optional
        });
        next.internalTests.optionality = createValidation({
          message,
          name: 'optionality',
          test(value) {
            return value === undefined ? this.schema.spec.optional : true;
          }
        });
        return next;
      }
      optional() {
        return this.optionality(true);
      }
      defined(message = mixed.defined) {
        return this.optionality(false, message);
      }
      nullable() {
        return this.nullability(true);
      }
      nonNullable(message = mixed.notNull) {
        return this.nullability(false, message);
      }
      required(message = mixed.required) {
        return this.clone().withMutation(next => next.nonNullable(message).defined(message));
      }
      notRequired() {
        return this.clone().withMutation(next => next.nullable().optional());
      }
      transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
      }

      /**
       * Adds a test function to the schema's queue of tests.
       * tests can be exclusive or non-exclusive.
       *
       * - exclusive tests, will replace any existing tests of the same name.
       * - non-exclusive: can be stacked
       *
       * If a non-exclusive test is added to a schema with an exclusive test of the same name
       * the exclusive test is removed and further tests of the same name will be stacked.
       *
       * If an exclusive test is added to a schema with non-exclusive tests of the same name
       * the previous tests are removed and further tests of the same name will replace each other.
       */

      test(...args) {
        let opts;
        if (args.length === 1) {
          if (typeof args[0] === 'function') {
            opts = {
              test: args[0]
            };
          } else {
            opts = args[0];
          }
        } else if (args.length === 2) {
          opts = {
            name: args[0],
            test: args[1]
          };
        } else {
          opts = {
            name: args[0],
            message: args[1],
            test: args[2]
          };
        }
        if (opts.message === undefined) opts.message = mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
          if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter(fn => {
          if (fn.OPTIONS.name === opts.name) {
            if (isExclusive) return false;
            if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
          }
          return true;
        });
        next.tests.push(validate);
        return next;
      }
      when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
          options = keys;
          keys = '.';
        }
        let next = this.clone();
        let deps = toArray(keys).map(key => new Reference(key));
        deps.forEach(dep => {
          // @ts-ignore readonly array
          if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
        return next;
      }
      typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = createValidation({
          message,
          name: 'typeError',
          skipAbsent: true,
          test(value) {
            if (!this.schema._typeCheck(value)) return this.createError({
              params: {
                type: this.schema.type
              }
            });
            return true;
          }
        });
        return next;
      }
      oneOf(enums, message = mixed.oneOf) {
        let next = this.clone();
        enums.forEach(val => {
          next._whitelist.add(val);
          next._blacklist.delete(val);
        });
        next.internalTests.whiteList = createValidation({
          message,
          name: 'oneOf',
          skipAbsent: true,
          test(value) {
            let valids = this.schema._whitelist;
            let resolved = valids.resolveAll(this.resolve);
            return resolved.includes(value) ? true : this.createError({
              params: {
                values: Array.from(valids).join(', '),
                resolved
              }
            });
          }
        });
        return next;
      }
      notOneOf(enums, message = mixed.notOneOf) {
        let next = this.clone();
        enums.forEach(val => {
          next._blacklist.add(val);
          next._whitelist.delete(val);
        });
        next.internalTests.blacklist = createValidation({
          message,
          name: 'notOneOf',
          test(value) {
            let invalids = this.schema._blacklist;
            let resolved = invalids.resolveAll(this.resolve);
            if (resolved.includes(value)) return this.createError({
              params: {
                values: Array.from(invalids).join(', '),
                resolved
              }
            });
            return true;
          }
        });
        return next;
      }
      strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
      }

      /**
       * Return a serialized description of the schema including validations, flags, types etc.
       *
       * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
       */
      describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const {
          label,
          meta,
          optional,
          nullable
        } = next.spec;
        const description = {
          meta,
          label,
          optional,
          nullable,
          default: next.getDefault(options),
          type: next.type,
          oneOf: next._whitelist.describe(),
          notOneOf: next._blacklist.describe(),
          tests: next.tests.map(fn => ({
            name: fn.OPTIONS.name,
            params: fn.OPTIONS.params
          })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
        };
        return description;
      }
    }
    // @ts-expect-error
    Schema.prototype.__isYupSchema__ = true;
    for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
      const {
        parent,
        parentPath,
        schema
      } = getIn(this, path, value, options.context);
      return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent,
        path
      }));
    };
    for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
    for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

    /**
     * This file is a modified version of the file from the following repository:
     * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
     * NON-CONFORMANT EDITION.
     * © 2011 Colin Snover <http://zetafleet.com>
     * Released under MIT license.
     */

    // prettier-ignore
    //                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
    const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
    function parseIsoDate(date) {
      const struct = parseDateStruct(date);
      if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

      // timestamps without timezone identifiers should be considered local time
      if (struct.z === undefined && struct.plusMinus === undefined) {
        return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
      }
      let totalMinutesOffset = 0;
      if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
      }
      return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
    }
    function parseDateStruct(date) {
      var _regexResult$7$length, _regexResult$;
      const regexResult = isoReg.exec(date);
      if (!regexResult) return null;

      // use of toNumber() avoids NaN timestamps caused by “undefined”
      // values being passed to Date constructor
      return {
        year: toNumber(regexResult[1]),
        month: toNumber(regexResult[2], 1) - 1,
        day: toNumber(regexResult[3], 1),
        hour: toNumber(regexResult[4]),
        minute: toNumber(regexResult[5]),
        second: toNumber(regexResult[6]),
        millisecond: regexResult[7] ?
        // allow arbitrary sub-second precision beyond milliseconds
        toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: toNumber(regexResult[10]),
        minuteOffset: toNumber(regexResult[11])
      };
    }
    function toNumber(str, defaultValue = 0) {
      return Number(str) || defaultValue;
    }

    // Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
    let rEmail =
    // eslint-disable-next-line
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    let rUrl =
    // eslint-disable-next-line
    /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

    // eslint-disable-next-line
    let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
    let yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
    let hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
    let zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
    let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
    let isTrimmed = value => isAbsent(value) || value === value.trim();
    let objStringTag = {}.toString();
    function create$6() {
      return new StringSchema();
    }
    class StringSchema extends Schema {
      constructor() {
        super({
          type: 'string',
          check(value) {
            if (value instanceof String) value = value.valueOf();
            return typeof value === 'string';
          }
        });
        this.withMutation(() => {
          this.transform((value, _raw, ctx) => {
            if (!ctx.spec.coerce || ctx.isType(value)) return value;

            // don't ever convert arrays
            if (Array.isArray(value)) return value;
            const strValue = value != null && value.toString ? value.toString() : value;

            // no one wants plain objects converted to [Object object]
            if (strValue === objStringTag) return value;
            return strValue;
          });
        });
      }
      required(message) {
        return super.required(message).withMutation(schema => schema.test({
          message: message || mixed.required,
          name: 'required',
          skipAbsent: true,
          test: value => !!value.length
        }));
      }
      notRequired() {
        return super.notRequired().withMutation(schema => {
          schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
          return schema;
        });
      }
      length(length, message = string.length) {
        return this.test({
          message,
          name: 'length',
          exclusive: true,
          params: {
            length
          },
          skipAbsent: true,
          test(value) {
            return value.length === this.resolve(length);
          }
        });
      }
      min(min, message = string.min) {
        return this.test({
          message,
          name: 'min',
          exclusive: true,
          params: {
            min
          },
          skipAbsent: true,
          test(value) {
            return value.length >= this.resolve(min);
          }
        });
      }
      max(max, message = string.max) {
        return this.test({
          name: 'max',
          exclusive: true,
          message,
          params: {
            max
          },
          skipAbsent: true,
          test(value) {
            return value.length <= this.resolve(max);
          }
        });
      }
      matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
          if (typeof options === 'object') {
            ({
              excludeEmptyString = false,
              message,
              name
            } = options);
          } else {
            message = options;
          }
        }
        return this.test({
          name: name || 'matches',
          message: message || string.matches,
          params: {
            regex
          },
          skipAbsent: true,
          test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
        });
      }
      email(message = string.email) {
        return this.matches(rEmail, {
          name: 'email',
          message,
          excludeEmptyString: true
        });
      }
      url(message = string.url) {
        return this.matches(rUrl, {
          name: 'url',
          message,
          excludeEmptyString: true
        });
      }
      uuid(message = string.uuid) {
        return this.matches(rUUID, {
          name: 'uuid',
          message,
          excludeEmptyString: false
        });
      }
      datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
          if (typeof options === 'object') {
            ({
              message = '',
              allowOffset = false,
              precision = undefined
            } = options);
          } else {
            message = options;
          }
        }
        return this.matches(rIsoDateTime, {
          name: 'datetime',
          message: message || string.datetime,
          excludeEmptyString: true
        }).test({
          name: 'datetime_offset',
          message: message || string.datetime_offset,
          params: {
            allowOffset
          },
          skipAbsent: true,
          test: value => {
            if (!value || allowOffset) return true;
            const struct = parseDateStruct(value);
            if (!struct) return false;
            return !!struct.z;
          }
        }).test({
          name: 'datetime_precision',
          message: message || string.datetime_precision,
          params: {
            precision
          },
          skipAbsent: true,
          test: value => {
            if (!value || precision == undefined) return true;
            const struct = parseDateStruct(value);
            if (!struct) return false;
            return struct.precision === precision;
          }
        });
      }

      //-- transforms --
      ensure() {
        return this.default('').transform(val => val === null ? '' : val);
      }
      trim(message = string.trim) {
        return this.transform(val => val != null ? val.trim() : val).test({
          message,
          name: 'trim',
          test: isTrimmed
        });
      }
      lowercase(message = string.lowercase) {
        return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
          message,
          name: 'string_case',
          exclusive: true,
          skipAbsent: true,
          test: value => isAbsent(value) || value === value.toLowerCase()
        });
      }
      uppercase(message = string.uppercase) {
        return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
          message,
          name: 'string_case',
          exclusive: true,
          skipAbsent: true,
          test: value => isAbsent(value) || value === value.toUpperCase()
        });
      }
    }
    create$6.prototype = StringSchema.prototype;

    //
    // Number Interfaces
    //

    let invalidDate = new Date('');
    let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
    class DateSchema extends Schema {
      constructor() {
        super({
          type: 'date',
          check(v) {
            return isDate(v) && !isNaN(v.getTime());
          }
        });
        this.withMutation(() => {
          this.transform((value, _raw, ctx) => {
            // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
            // nullability check vs TypeErrors
            if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
            value = parseIsoDate(value);

            // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
            return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
          });
        });
      }
      prepareParam(ref, name) {
        let param;
        if (!Reference.isRef(ref)) {
          let cast = this.cast(ref);
          if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
          param = cast;
        } else {
          param = ref;
        }
        return param;
      }
      min(min, message = date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
          message,
          name: 'min',
          exclusive: true,
          params: {
            min
          },
          skipAbsent: true,
          test(value) {
            return value >= this.resolve(limit);
          }
        });
      }
      max(max, message = date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
          message,
          name: 'max',
          exclusive: true,
          params: {
            max
          },
          skipAbsent: true,
          test(value) {
            return value <= this.resolve(limit);
          }
        });
      }
    }
    DateSchema.INVALID_DATE = invalidDate;
    DateSchema.prototype;

    // @ts-expect-error
    function sortFields(fields, excludedEdges = []) {
      let edges = [];
      let nodes = new Set();
      let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
      function addNode(depPath, key) {
        let node = propertyExpr.split(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
      }
      for (const key of Object.keys(fields)) {
        let value = fields[key];
        nodes.add(key);
        if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
      }
      return toposort_1.array(Array.from(nodes), edges).reverse();
    }

    function findIndex(arr, err) {
      let idx = Infinity;
      arr.some((key, ii) => {
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
          idx = ii;
          return true;
        }
      });
      return idx;
    }
    function sortByKeyOrder(keys) {
      return (a, b) => {
        return findIndex(keys, a) - findIndex(keys, b);
      };
    }

    const parseJson = (value, _, ctx) => {
      if (typeof value !== 'string') {
        return value;
      }
      let parsed = value;
      try {
        parsed = JSON.parse(value);
      } catch (err) {
        /* */
      }
      return ctx.isType(parsed) ? parsed : value;
    };

    // @ts-ignore
    function deepPartial(schema) {
      if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields)) {
          partial[key] = deepPartial(fieldSchema);
        }
        return schema.setFields(partial);
      }
      if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
        return nextArray;
      }
      if (schema.type === 'tuple') {
        return schema.optional().clone({
          types: schema.spec.types.map(deepPartial)
        });
      }
      if ('optional' in schema) {
        return schema.optional();
      }
      return schema;
    }
    const deepHas = (obj, p) => {
      const path = [...propertyExpr.normalizePath(p)];
      if (path.length === 1) return path[0] in obj;
      let last = path.pop();
      let parent = propertyExpr.getter(propertyExpr.join(path), true)(obj);
      return !!(parent && last in parent);
    };
    let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
    function unknown(ctx, value) {
      let known = Object.keys(ctx.fields);
      return Object.keys(value).filter(key => known.indexOf(key) === -1);
    }
    const defaultSort = sortByKeyOrder([]);
    function create$3(spec) {
      return new ObjectSchema(spec);
    }
    class ObjectSchema extends Schema {
      constructor(spec) {
        super({
          type: 'object',
          check(value) {
            return isObject(value) || typeof value === 'function';
          }
        });
        this.fields = Object.create(null);
        this._sortErrors = defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(() => {
          if (spec) {
            this.shape(spec);
          }
        });
      }
      _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);

        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
          parent: intermediateValue,
          __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props) {
          let field = fields[prop];
          let exists = (prop in value);
          if (field) {
            let fieldValue;
            let inputValue = value[prop];

            // safe to mutate since this is fired in sequence
            innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
            field = field.resolve({
              value: inputValue,
              context: options.context,
              parent: intermediateValue
            });
            let fieldSpec = field instanceof Schema ? field.spec : undefined;
            let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
            if (fieldSpec != null && fieldSpec.strip) {
              isChanged = isChanged || prop in value;
              continue;
            }
            fieldValue = !options.__validating || !strict ?
            // TODO: use _cast, this is double resolving
            field.cast(value[prop], innerOptions) : value[prop];
            if (fieldValue !== undefined) {
              intermediateValue[prop] = fieldValue;
            }
          } else if (exists && !strip) {
            intermediateValue[prop] = value[prop];
          }
          if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
            isChanged = true;
          }
        }
        return isChanged ? intermediateValue : value;
      }
      _validate(_value, options = {}, panic, next) {
        let {
          from = [],
          originalValue = _value,
          recursive = this.spec.recursive
        } = options;
        options.from = [{
          schema: this,
          value: originalValue
        }, ...from];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value) => {
          if (!recursive || !isObject(value)) {
            next(objectErrors, value);
            return;
          }
          originalValue = originalValue || value;
          let tests = [];
          for (let key of this._nodes) {
            let field = this.fields[key];
            if (!field || Reference.isRef(field)) {
              continue;
            }
            tests.push(field.asNestedTest({
              options,
              key,
              parent: value,
              parentPath: options.path,
              originalParent: originalValue
            }));
          }
          this.runTests({
            tests,
            value,
            originalValue,
            options
          }, panic, fieldErrors => {
            next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
          });
        });
      }
      clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
      }
      concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)) {
          const target = nextFields[field];
          nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation(s =>
        // XXX: excludes here is wrong
        s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
      }
      _getDefault(options) {
        if ('default' in this.spec) {
          return super._getDefault(options);
        }

        // if there is no default set invent one
        if (!this._nodes.length) {
          return undefined;
        }
        let dft = {};
        this._nodes.forEach(key => {
          var _innerOptions;
          const field = this.fields[key];
          let innerOptions = options;
          if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
            innerOptions = Object.assign({}, innerOptions, {
              parent: innerOptions.value,
              value: innerOptions.value[key]
            });
          }
          dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
      }
      setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = sortFields(shape, excludedEdges);
        next._sortErrors = sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
      }
      shape(additions, excludes = []) {
        return this.clone().withMutation(next => {
          let edges = next._excludedEdges;
          if (excludes.length) {
            if (!Array.isArray(excludes[0])) excludes = [excludes];
            edges = [...next._excludedEdges, ...excludes];
          }

          // XXX: excludes here is wrong
          return next.setFields(Object.assign(next.fields, additions), edges);
        });
      }
      partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields)) {
          partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        }
        return this.setFields(partial);
      }
      deepPartial() {
        const next = deepPartial(this);
        return next;
      }
      pick(keys) {
        const picked = {};
        for (const key of keys) {
          if (this.fields[key]) picked[key] = this.fields[key];
        }
        return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys.includes(a) && keys.includes(b)));
      }
      omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)) {
          if (keys.includes(key)) continue;
          remaining.push(key);
        }
        return this.pick(remaining);
      }
      from(from, to, alias) {
        let fromGetter = propertyExpr.getter(from, true);
        return this.transform(obj => {
          if (!obj) return obj;
          let newObj = obj;
          if (deepHas(obj, from)) {
            newObj = Object.assign({}, obj);
            if (!alias) delete newObj[from];
            newObj[to] = fromGetter(obj);
          }
          return newObj;
        });
      }

      /** Parse an input JSON string to an object */
      json() {
        return this.transform(parseJson);
      }
      noUnknown(noAllow = true, message = object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
          message = noAllow;
          noAllow = true;
        }
        let next = this.test({
          name: 'noUnknown',
          exclusive: true,
          message: message,
          test(value) {
            if (value == null) return true;
            const unknownKeys = unknown(this.schema, value);
            return !noAllow || unknownKeys.length === 0 || this.createError({
              params: {
                unknown: unknownKeys.join(', ')
              }
            });
          }
        });
        next.spec.noUnknown = noAllow;
        return next;
      }
      unknown(allow = true, message = object.noUnknown) {
        return this.noUnknown(!allow, message);
      }
      transformKeys(fn) {
        return this.transform(obj => {
          if (!obj) return obj;
          const result = {};
          for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
          return result;
        });
      }
      camelCase() {
        return this.transformKeys(tinyCase.camelCase);
      }
      snakeCase() {
        return this.transformKeys(tinyCase.snakeCase);
      }
      constantCase() {
        return this.transformKeys(key => tinyCase.snakeCase(key).toUpperCase());
      }
      describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)) {
          var _innerOptions2;
          let innerOptions = options;
          if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
            innerOptions = Object.assign({}, innerOptions, {
              parent: innerOptions.value,
              value: innerOptions.value[key]
            });
          }
          base.fields[key] = value.describe(innerOptions);
        }
        return base;
      }
    }
    create$3.prototype = ObjectSchema.prototype;

    const formSchema = create$3().shape({
        firstName: create$6().required().label("First Name"),
        lastName: create$6().required().label("Last Name"),
        addressLine1: create$6().required().label("Address Line 1"),
        addressLine2: create$6().optional().label("Address Line 2"),
        city: create$6().required().label("City"),
        state: create$6().oneOf(Object.keys(STATES), "State is required").required().label("State"),
        zipcode: create$6().matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Zipcode is invalid').required().label("Zipcode"),
        email: create$6().required().email().label("Email address"),
    });

    let schemaKey =  Symbol('schema');
    let fieldsKey =  Symbol('fields');
    let submittedKey =  Symbol('submitted');
    let colorKey =  Symbol('color');

    /* node_modules/svelte-yup/src/Form.svelte generated by Svelte v3.59.2 */

    function create_fragment$5(ctx) {
    	let form;
    	let current;
    	let mounted;
    	let dispose;
    	const default_slot_template = /*#slots*/ ctx[11].default;
    	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[10], null);
    	let form_levels = [/*$$props*/ ctx[5]];
    	let form_data = {};

    	for (let i = 0; i < form_levels.length; i += 1) {
    		form_data = assign(form_data, form_levels[i]);
    	}

    	return {
    		c() {
    			form = element("form");
    			if (default_slot) default_slot.c();
    			set_attributes(form, form_data);
    		},
    		m(target, anchor) {
    			insert(target, form, anchor);

    			if (default_slot) {
    				default_slot.m(form, null);
    			}

    			current = true;

    			if (!mounted) {
    				dispose = listen(form, "submit", prevent_default(function () {
    					if (is_function(/*submitHandler*/ ctx[0])) /*submitHandler*/ ctx[0].apply(this, arguments);
    				}));

    				mounted = true;
    			}
    		},
    		p(new_ctx, [dirty]) {
    			ctx = new_ctx;

    			if (default_slot) {
    				if (default_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
    					update_slot_base(
    						default_slot,
    						default_slot_template,
    						ctx,
    						/*$$scope*/ ctx[10],
    						!current
    						? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
    						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[10], dirty, null),
    						null
    					);
    				}
    			}

    			set_attributes(form, form_data = get_spread_update(form_levels, [dirty & /*$$props*/ 32 && /*$$props*/ ctx[5]]));
    		},
    		i(local) {
    			if (current) return;
    			transition_in(default_slot, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(default_slot, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(form);
    			if (default_slot) default_slot.d(detaching);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$5($$self, $$props, $$invalidate) {
    	let $messageColor;
    	let $formSubmitted;
    	let $formSchema;
    	let $formFields;
    	let { $$slots: slots = {}, $$scope } = $$props;
    	let { submitHandler } = $$props;
    	let { schema } = $$props;
    	let { fields } = $$props;
    	let { submitted } = $$props;
    	let { color = 'red' } = $$props;
    	let formSchema = writable(schema);
    	component_subscribe($$self, formSchema, value => $$invalidate(14, $formSchema = value));
    	let formFields = writable(fields);
    	component_subscribe($$self, formFields, value => $$invalidate(15, $formFields = value));
    	let formSubmitted = writable(submitted);
    	component_subscribe($$self, formSubmitted, value => $$invalidate(13, $formSubmitted = value));
    	let messageColor = writable(color);
    	component_subscribe($$self, messageColor, value => $$invalidate(12, $messageColor = value));
    	setContext(schemaKey, formSchema);
    	setContext(fieldsKey, formFields);
    	setContext(submittedKey, formSubmitted);
    	setContext(colorKey, messageColor);

    	$$self.$$set = $$new_props => {
    		$$invalidate(5, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
    		if ('submitHandler' in $$new_props) $$invalidate(0, submitHandler = $$new_props.submitHandler);
    		if ('schema' in $$new_props) $$invalidate(6, schema = $$new_props.schema);
    		if ('fields' in $$new_props) $$invalidate(7, fields = $$new_props.fields);
    		if ('submitted' in $$new_props) $$invalidate(8, submitted = $$new_props.submitted);
    		if ('color' in $$new_props) $$invalidate(9, color = $$new_props.color);
    		if ('$$scope' in $$new_props) $$invalidate(10, $$scope = $$new_props.$$scope);
    	};

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*fields*/ 128) {
    			set_store_value(formFields, $formFields = fields, $formFields);
    		}

    		if ($$self.$$.dirty & /*schema*/ 64) {
    			set_store_value(formSchema, $formSchema = schema, $formSchema);
    		}

    		if ($$self.$$.dirty & /*submitted*/ 256) {
    			set_store_value(formSubmitted, $formSubmitted = submitted, $formSubmitted);
    		}

    		if ($$self.$$.dirty & /*color*/ 512) {
    			set_store_value(messageColor, $messageColor = color, $messageColor);
    		}
    	};

    	$$props = exclude_internal_props($$props);

    	return [
    		submitHandler,
    		formSchema,
    		formFields,
    		formSubmitted,
    		messageColor,
    		$$props,
    		schema,
    		fields,
    		submitted,
    		color,
    		$$scope,
    		slots
    	];
    }

    class Form extends SvelteComponent {
    	constructor(options) {
    		super();

    		init(this, options, instance$5, create_fragment$5, safe_not_equal, {
    			submitHandler: 0,
    			schema: 6,
    			fields: 7,
    			submitted: 8,
    			color: 9
    		});
    	}
    }

    /* node_modules/svelte-yup/src/Message.svelte generated by Svelte v3.59.2 */

    function add_css$4(target) {
    	append_styles(target, "svelte-x2gjbb", "p.invalid.svelte-x2gjbb{font-size:14px}p.valid.svelte-x2gjbb{display:inline}");
    }

    // (12:0) {#if $submitted}
    function create_if_block$2(ctx) {
    	let await_block_anchor;
    	let promise;

    	let info = {
    		ctx,
    		current: null,
    		token: null,
    		hasCatch: true,
    		pending: create_pending_block,
    		then: create_then_block,
    		catch: create_catch_block,
    		value: 9,
    		error: 10
    	};

    	handle_promise(promise = /*$schema*/ ctx[2].validateAt(/*name*/ ctx[0], /*$fields*/ ctx[3]), info);

    	return {
    		c() {
    			await_block_anchor = empty();
    			info.block.c();
    		},
    		m(target, anchor) {
    			insert(target, await_block_anchor, anchor);
    			info.block.m(target, info.anchor = anchor);
    			info.mount = () => await_block_anchor.parentNode;
    			info.anchor = await_block_anchor;
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			info.ctx = ctx;

    			if (dirty & /*$schema, name, $fields*/ 13 && promise !== (promise = /*$schema*/ ctx[2].validateAt(/*name*/ ctx[0], /*$fields*/ ctx[3])) && handle_promise(promise, info)) ; else {
    				update_await_block_branch(info, ctx, dirty);
    			}
    		},
    		d(detaching) {
    			if (detaching) detach(await_block_anchor);
    			info.block.d(detaching);
    			info.token = null;
    			info = null;
    		}
    	};
    }

    // (15:8) {:catch error}
    function create_catch_block(ctx) {
    	let p;
    	let t_value = /*error*/ ctx[10].errors[0] + "";
    	let t;

    	return {
    		c() {
    			p = element("p");
    			t = text(t_value);
    			attr(p, "class", "invalid svelte-x2gjbb");
    			set_style(p, "color", /*$color*/ ctx[4]);
    		},
    		m(target, anchor) {
    			insert(target, p, anchor);
    			append(p, t);
    		},
    		p(ctx, dirty) {
    			if (dirty & /*$schema, name, $fields*/ 13 && t_value !== (t_value = /*error*/ ctx[10].errors[0] + "")) set_data(t, t_value);

    			if (dirty & /*$color*/ 16) {
    				set_style(p, "color", /*$color*/ ctx[4]);
    			}
    		},
    		d(detaching) {
    			if (detaching) detach(p);
    		}
    	};
    }

    // (13:58)           <p class="valid"></p>          {:catch error}
    function create_then_block(ctx) {
    	let p;

    	return {
    		c() {
    			p = element("p");
    			attr(p, "class", "valid svelte-x2gjbb");
    		},
    		m(target, anchor) {
    			insert(target, p, anchor);
    		},
    		p: noop,
    		d(detaching) {
    			if (detaching) detach(p);
    		}
    	};
    }

    // (1:0) <script>      import {getContext}
    function create_pending_block(ctx) {
    	return { c: noop, m: noop, p: noop, d: noop };
    }

    function create_fragment$4(ctx) {
    	let if_block_anchor;
    	let if_block = /*$submitted*/ ctx[1] && create_if_block$2(ctx);

    	return {
    		c() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    		},
    		m(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert(target, if_block_anchor, anchor);
    		},
    		p(ctx, [dirty]) {
    			if (/*$submitted*/ ctx[1]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$2(ctx);
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (if_block) if_block.d(detaching);
    			if (detaching) detach(if_block_anchor);
    		}
    	};
    }

    function instance$4($$self, $$props, $$invalidate) {
    	let $submitted;
    	let $schema;
    	let $fields;
    	let $color;
    	let { name } = $$props;
    	let schema = getContext(schemaKey);
    	component_subscribe($$self, schema, value => $$invalidate(2, $schema = value));
    	let fields = getContext(fieldsKey);
    	component_subscribe($$self, fields, value => $$invalidate(3, $fields = value));
    	let submitted = getContext(submittedKey);
    	component_subscribe($$self, submitted, value => $$invalidate(1, $submitted = value));
    	let color = getContext(colorKey);
    	component_subscribe($$self, color, value => $$invalidate(4, $color = value));

    	$$self.$$set = $$props => {
    		if ('name' in $$props) $$invalidate(0, name = $$props.name);
    	};

    	return [name, $submitted, $schema, $fields, $color, schema, fields, submitted, color];
    }

    class Message extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$4, create_fragment$4, safe_not_equal, { name: 0 }, add_css$4);
    	}
    }

    class FormController {
        _isValidURL(urlString) {
            try {
                new URL(urlString);
                return true;
            }
            catch (e) {
                return false;
            }
        }
        async sendForm(fields) {
            const formUrl = get_store_value(_formUrl);
            if (!this._isValidURL(formUrl))
                return;
            const selected = get_store_value(_selectedVariants);
            if (!selected.length)
                return;
            _isLoading.update(() => true);
            const swatchImageUrl = selected.map(item => item.image).join(', ');
            const swatchName = selected.map(item => item.title).join(', ');
            const request = await fetch(formUrl, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(Object.assign(Object.assign({}, fields), { swatchImageUrl,
                    swatchName }))
            });
            const response = await request.json();
            _isLoading.update(() => false);
            return response.code === 200;
        }
    }
    var FormController$1 = new FormController();

    /* src/components/pages/FormPage.svelte generated by Svelte v3.59.2 */

    function add_css$3(target) {
    	append_styles(target, "svelte-1o4w5yg", ".FormPage.svelte-1o4w5yg{height:100%;display:flex;flex-direction:column}.FormPage__body.svelte-1o4w5yg{flex:1;overflow-y:auto;overflow-x:hidden;padding:20px}.FormPage__row.svelte-1o4w5yg{display:grid;-moz-column-gap:30px;column-gap:30px;margin-bottom:20px}.FormPage__row--2.svelte-1o4w5yg{grid-template-columns:1fr 1fr}");
    }

    // (41:16) <FormInput label="First Name" bind:value={fields.firstName}>
    function create_default_slot_9(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "firstName" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (44:16) <FormInput label="Last Name" bind:value={fields.lastName}>
    function create_default_slot_8(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "lastName" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (50:16) <FormInput label="Address line 1" bind:value={fields.addressLine1}>
    function create_default_slot_7(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "addressLine1" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (56:16) <FormInput label="Address line 2" bind:value={fields.addressLine2}>
    function create_default_slot_6(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "addressLine2" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (62:16) <FormInput label="City" bind:value={fields.city}>
    function create_default_slot_5(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "city" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (68:16) <FormSelect label="State" bind:value={fields.state} options={STATES}>
    function create_default_slot_4(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "state" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (71:16) <FormInput label="Zipcode" bind:value={fields.zipcode}>
    function create_default_slot_3(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "zipcode" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (77:16) <FormInput label="Email" type="email" bind:value={fields.email}>
    function create_default_slot_2(ctx) {
    	let message;
    	let current;
    	message = new Message({ props: { name: "email" } });

    	return {
    		c() {
    			create_component(message.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(message, target, anchor);
    			current = true;
    		},
    		p: noop,
    		i(local) {
    			if (current) return;
    			transition_in(message.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(message.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(message, detaching);
    		}
    	};
    }

    // (39:8) <Form schema={formSchema} {fields} {submitted}>
    function create_default_slot_1(ctx) {
    	let div0;
    	let forminput0;
    	let updating_value;
    	let t0;
    	let forminput1;
    	let updating_value_1;
    	let t1;
    	let div1;
    	let forminput2;
    	let updating_value_2;
    	let t2;
    	let div2;
    	let forminput3;
    	let updating_value_3;
    	let t3;
    	let div3;
    	let forminput4;
    	let updating_value_4;
    	let t4;
    	let div4;
    	let formselect;
    	let updating_value_5;
    	let t5;
    	let forminput5;
    	let updating_value_6;
    	let t6;
    	let div5;
    	let forminput6;
    	let updating_value_7;
    	let current;

    	function forminput0_value_binding(value) {
    		/*forminput0_value_binding*/ ctx[4](value);
    	}

    	let forminput0_props = {
    		label: "First Name",
    		$$slots: { default: [create_default_slot_9] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].firstName !== void 0) {
    		forminput0_props.value = /*fields*/ ctx[0].firstName;
    	}

    	forminput0 = new FormInput({ props: forminput0_props });
    	binding_callbacks.push(() => bind(forminput0, 'value', forminput0_value_binding));

    	function forminput1_value_binding(value) {
    		/*forminput1_value_binding*/ ctx[5](value);
    	}

    	let forminput1_props = {
    		label: "Last Name",
    		$$slots: { default: [create_default_slot_8] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].lastName !== void 0) {
    		forminput1_props.value = /*fields*/ ctx[0].lastName;
    	}

    	forminput1 = new FormInput({ props: forminput1_props });
    	binding_callbacks.push(() => bind(forminput1, 'value', forminput1_value_binding));

    	function forminput2_value_binding(value) {
    		/*forminput2_value_binding*/ ctx[6](value);
    	}

    	let forminput2_props = {
    		label: "Address line 1",
    		$$slots: { default: [create_default_slot_7] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].addressLine1 !== void 0) {
    		forminput2_props.value = /*fields*/ ctx[0].addressLine1;
    	}

    	forminput2 = new FormInput({ props: forminput2_props });
    	binding_callbacks.push(() => bind(forminput2, 'value', forminput2_value_binding));

    	function forminput3_value_binding(value) {
    		/*forminput3_value_binding*/ ctx[7](value);
    	}

    	let forminput3_props = {
    		label: "Address line 2",
    		$$slots: { default: [create_default_slot_6] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].addressLine2 !== void 0) {
    		forminput3_props.value = /*fields*/ ctx[0].addressLine2;
    	}

    	forminput3 = new FormInput({ props: forminput3_props });
    	binding_callbacks.push(() => bind(forminput3, 'value', forminput3_value_binding));

    	function forminput4_value_binding(value) {
    		/*forminput4_value_binding*/ ctx[8](value);
    	}

    	let forminput4_props = {
    		label: "City",
    		$$slots: { default: [create_default_slot_5] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].city !== void 0) {
    		forminput4_props.value = /*fields*/ ctx[0].city;
    	}

    	forminput4 = new FormInput({ props: forminput4_props });
    	binding_callbacks.push(() => bind(forminput4, 'value', forminput4_value_binding));

    	function formselect_value_binding(value) {
    		/*formselect_value_binding*/ ctx[9](value);
    	}

    	let formselect_props = {
    		label: "State",
    		options: STATES,
    		$$slots: { default: [create_default_slot_4] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].state !== void 0) {
    		formselect_props.value = /*fields*/ ctx[0].state;
    	}

    	formselect = new FormSelect({ props: formselect_props });
    	binding_callbacks.push(() => bind(formselect, 'value', formselect_value_binding));

    	function forminput5_value_binding(value) {
    		/*forminput5_value_binding*/ ctx[10](value);
    	}

    	let forminput5_props = {
    		label: "Zipcode",
    		$$slots: { default: [create_default_slot_3] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].zipcode !== void 0) {
    		forminput5_props.value = /*fields*/ ctx[0].zipcode;
    	}

    	forminput5 = new FormInput({ props: forminput5_props });
    	binding_callbacks.push(() => bind(forminput5, 'value', forminput5_value_binding));

    	function forminput6_value_binding(value) {
    		/*forminput6_value_binding*/ ctx[11](value);
    	}

    	let forminput6_props = {
    		label: "Email",
    		type: "email",
    		$$slots: { default: [create_default_slot_2] },
    		$$scope: { ctx }
    	};

    	if (/*fields*/ ctx[0].email !== void 0) {
    		forminput6_props.value = /*fields*/ ctx[0].email;
    	}

    	forminput6 = new FormInput({ props: forminput6_props });
    	binding_callbacks.push(() => bind(forminput6, 'value', forminput6_value_binding));

    	return {
    		c() {
    			div0 = element("div");
    			create_component(forminput0.$$.fragment);
    			t0 = space();
    			create_component(forminput1.$$.fragment);
    			t1 = space();
    			div1 = element("div");
    			create_component(forminput2.$$.fragment);
    			t2 = space();
    			div2 = element("div");
    			create_component(forminput3.$$.fragment);
    			t3 = space();
    			div3 = element("div");
    			create_component(forminput4.$$.fragment);
    			t4 = space();
    			div4 = element("div");
    			create_component(formselect.$$.fragment);
    			t5 = space();
    			create_component(forminput5.$$.fragment);
    			t6 = space();
    			div5 = element("div");
    			create_component(forminput6.$$.fragment);
    			attr(div0, "class", "FormPage__row FormPage__row--2 svelte-1o4w5yg");
    			attr(div1, "class", "FormPage__row svelte-1o4w5yg");
    			attr(div2, "class", "FormPage__row svelte-1o4w5yg");
    			attr(div3, "class", "FormPage__row svelte-1o4w5yg");
    			attr(div4, "class", "FormPage__row FormPage__row--2 svelte-1o4w5yg");
    			attr(div5, "class", "FormPage__row svelte-1o4w5yg");
    		},
    		m(target, anchor) {
    			insert(target, div0, anchor);
    			mount_component(forminput0, div0, null);
    			append(div0, t0);
    			mount_component(forminput1, div0, null);
    			insert(target, t1, anchor);
    			insert(target, div1, anchor);
    			mount_component(forminput2, div1, null);
    			insert(target, t2, anchor);
    			insert(target, div2, anchor);
    			mount_component(forminput3, div2, null);
    			insert(target, t3, anchor);
    			insert(target, div3, anchor);
    			mount_component(forminput4, div3, null);
    			insert(target, t4, anchor);
    			insert(target, div4, anchor);
    			mount_component(formselect, div4, null);
    			append(div4, t5);
    			mount_component(forminput5, div4, null);
    			insert(target, t6, anchor);
    			insert(target, div5, anchor);
    			mount_component(forminput6, div5, null);
    			current = true;
    		},
    		p(ctx, dirty) {
    			const forminput0_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput0_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value && dirty & /*fields*/ 1) {
    				updating_value = true;
    				forminput0_changes.value = /*fields*/ ctx[0].firstName;
    				add_flush_callback(() => updating_value = false);
    			}

    			forminput0.$set(forminput0_changes);
    			const forminput1_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput1_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_1 && dirty & /*fields*/ 1) {
    				updating_value_1 = true;
    				forminput1_changes.value = /*fields*/ ctx[0].lastName;
    				add_flush_callback(() => updating_value_1 = false);
    			}

    			forminput1.$set(forminput1_changes);
    			const forminput2_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput2_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_2 && dirty & /*fields*/ 1) {
    				updating_value_2 = true;
    				forminput2_changes.value = /*fields*/ ctx[0].addressLine1;
    				add_flush_callback(() => updating_value_2 = false);
    			}

    			forminput2.$set(forminput2_changes);
    			const forminput3_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput3_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_3 && dirty & /*fields*/ 1) {
    				updating_value_3 = true;
    				forminput3_changes.value = /*fields*/ ctx[0].addressLine2;
    				add_flush_callback(() => updating_value_3 = false);
    			}

    			forminput3.$set(forminput3_changes);
    			const forminput4_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput4_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_4 && dirty & /*fields*/ 1) {
    				updating_value_4 = true;
    				forminput4_changes.value = /*fields*/ ctx[0].city;
    				add_flush_callback(() => updating_value_4 = false);
    			}

    			forminput4.$set(forminput4_changes);
    			const formselect_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				formselect_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_5 && dirty & /*fields*/ 1) {
    				updating_value_5 = true;
    				formselect_changes.value = /*fields*/ ctx[0].state;
    				add_flush_callback(() => updating_value_5 = false);
    			}

    			formselect.$set(formselect_changes);
    			const forminput5_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput5_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_6 && dirty & /*fields*/ 1) {
    				updating_value_6 = true;
    				forminput5_changes.value = /*fields*/ ctx[0].zipcode;
    				add_flush_callback(() => updating_value_6 = false);
    			}

    			forminput5.$set(forminput5_changes);
    			const forminput6_changes = {};

    			if (dirty & /*$$scope*/ 8192) {
    				forminput6_changes.$$scope = { dirty, ctx };
    			}

    			if (!updating_value_7 && dirty & /*fields*/ 1) {
    				updating_value_7 = true;
    				forminput6_changes.value = /*fields*/ ctx[0].email;
    				add_flush_callback(() => updating_value_7 = false);
    			}

    			forminput6.$set(forminput6_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(forminput0.$$.fragment, local);
    			transition_in(forminput1.$$.fragment, local);
    			transition_in(forminput2.$$.fragment, local);
    			transition_in(forminput3.$$.fragment, local);
    			transition_in(forminput4.$$.fragment, local);
    			transition_in(formselect.$$.fragment, local);
    			transition_in(forminput5.$$.fragment, local);
    			transition_in(forminput6.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(forminput0.$$.fragment, local);
    			transition_out(forminput1.$$.fragment, local);
    			transition_out(forminput2.$$.fragment, local);
    			transition_out(forminput3.$$.fragment, local);
    			transition_out(forminput4.$$.fragment, local);
    			transition_out(formselect.$$.fragment, local);
    			transition_out(forminput5.$$.fragment, local);
    			transition_out(forminput6.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div0);
    			destroy_component(forminput0);
    			destroy_component(forminput1);
    			if (detaching) detach(t1);
    			if (detaching) detach(div1);
    			destroy_component(forminput2);
    			if (detaching) detach(t2);
    			if (detaching) detach(div2);
    			destroy_component(forminput3);
    			if (detaching) detach(t3);
    			if (detaching) detach(div3);
    			destroy_component(forminput4);
    			if (detaching) detach(t4);
    			if (detaching) detach(div4);
    			destroy_component(formselect);
    			destroy_component(forminput5);
    			if (detaching) detach(t6);
    			if (detaching) detach(div5);
    			destroy_component(forminput6);
    		}
    	};
    }

    // (85:8) <Button onClick={formSubmit} disabled={$_isLoading}>
    function create_default_slot$1(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("Place Order");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    function create_fragment$3(ctx) {
    	let div2;
    	let div0;
    	let form;
    	let t;
    	let div1;
    	let button;
    	let current;

    	form = new Form({
    			props: {
    				schema: formSchema,
    				fields: /*fields*/ ctx[0],
    				submitted: /*submitted*/ ctx[1],
    				$$slots: { default: [create_default_slot_1] },
    				$$scope: { ctx }
    			}
    		});

    	button = new Button({
    			props: {
    				onClick: /*formSubmit*/ ctx[3],
    				disabled: /*$_isLoading*/ ctx[2],
    				$$slots: { default: [create_default_slot$1] },
    				$$scope: { ctx }
    			}
    		});

    	return {
    		c() {
    			div2 = element("div");
    			div0 = element("div");
    			create_component(form.$$.fragment);
    			t = space();
    			div1 = element("div");
    			create_component(button.$$.fragment);
    			attr(div0, "class", "FormPage__body svelte-1o4w5yg");
    			attr(div1, "class", "FormPage__footer");
    			attr(div2, "class", "FormPage svelte-1o4w5yg");
    		},
    		m(target, anchor) {
    			insert(target, div2, anchor);
    			append(div2, div0);
    			mount_component(form, div0, null);
    			append(div2, t);
    			append(div2, div1);
    			mount_component(button, div1, null);
    			current = true;
    		},
    		p(ctx, [dirty]) {
    			const form_changes = {};
    			if (dirty & /*fields*/ 1) form_changes.fields = /*fields*/ ctx[0];
    			if (dirty & /*submitted*/ 2) form_changes.submitted = /*submitted*/ ctx[1];

    			if (dirty & /*$$scope, fields*/ 8193) {
    				form_changes.$$scope = { dirty, ctx };
    			}

    			form.$set(form_changes);
    			const button_changes = {};
    			if (dirty & /*$_isLoading*/ 4) button_changes.disabled = /*$_isLoading*/ ctx[2];

    			if (dirty & /*$$scope*/ 8192) {
    				button_changes.$$scope = { dirty, ctx };
    			}

    			button.$set(button_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(form.$$.fragment, local);
    			transition_in(button.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(form.$$.fragment, local);
    			transition_out(button.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div2);
    			destroy_component(form);
    			destroy_component(button);
    		}
    	};
    }

    function instance$3($$self, $$props, $$invalidate) {
    	let $_isLoading;
    	component_subscribe($$self, _isLoading, $$value => $$invalidate(2, $_isLoading = $$value));

    	let fields = {
    		firstName: "",
    		lastName: "",
    		addressLine1: "",
    		addressLine2: "",
    		city: "",
    		state: "",
    		zipcode: "",
    		email: ""
    	};

    	let submitted = false;
    	let isValid;

    	async function formSubmit() {
    		$$invalidate(1, submitted = true);
    		isValid = formSchema.isValidSync(fields);

    		if (isValid) {
    			const result = await FormController$1.sendForm(fields);
    			_selectedVariants.update(() => []);
    			if (result) navTo(Page.ThankYou);
    		}
    	}

    	function forminput0_value_binding(value) {
    		if ($$self.$$.not_equal(fields.firstName, value)) {
    			fields.firstName = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput1_value_binding(value) {
    		if ($$self.$$.not_equal(fields.lastName, value)) {
    			fields.lastName = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput2_value_binding(value) {
    		if ($$self.$$.not_equal(fields.addressLine1, value)) {
    			fields.addressLine1 = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput3_value_binding(value) {
    		if ($$self.$$.not_equal(fields.addressLine2, value)) {
    			fields.addressLine2 = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput4_value_binding(value) {
    		if ($$self.$$.not_equal(fields.city, value)) {
    			fields.city = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function formselect_value_binding(value) {
    		if ($$self.$$.not_equal(fields.state, value)) {
    			fields.state = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput5_value_binding(value) {
    		if ($$self.$$.not_equal(fields.zipcode, value)) {
    			fields.zipcode = value;
    			$$invalidate(0, fields);
    		}
    	}

    	function forminput6_value_binding(value) {
    		if ($$self.$$.not_equal(fields.email, value)) {
    			fields.email = value;
    			$$invalidate(0, fields);
    		}
    	}

    	return [
    		fields,
    		submitted,
    		$_isLoading,
    		formSubmit,
    		forminput0_value_binding,
    		forminput1_value_binding,
    		forminput2_value_binding,
    		forminput3_value_binding,
    		forminput4_value_binding,
    		formselect_value_binding,
    		forminput5_value_binding,
    		forminput6_value_binding
    	];
    }

    class FormPage extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$3, create_fragment$3, safe_not_equal, {}, add_css$3);
    	}
    }

    /* src/components/pages/ThankYouPage.svelte generated by Svelte v3.59.2 */

    function add_css$2(target) {
    	append_styles(target, "svelte-1qfhl3f", ".ThankYouPage.svelte-1qfhl3f.svelte-1qfhl3f{height:100%;padding:20px;text-align:center;font-size:16px;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#000;font-family:Arial}.ThankYouPage.svelte-1qfhl3f img.svelte-1qfhl3f{margin-bottom:15px}.ThankYouPage.svelte-1qfhl3f.svelte-1qfhl3f:has(img){justify-content:flex-start}");
    }

    // (6:4) {#if $_thankYouImage}
    function create_if_block$1(ctx) {
    	let img;
    	let img_src_value;

    	return {
    		c() {
    			img = element("img");
    			if (!src_url_equal(img.src, img_src_value = /*$_thankYouImage*/ ctx[0])) attr(img, "src", img_src_value);
    			attr(img, "alt", "");
    			attr(img, "class", "svelte-1qfhl3f");
    		},
    		m(target, anchor) {
    			insert(target, img, anchor);
    		},
    		p(ctx, dirty) {
    			if (dirty & /*$_thankYouImage*/ 1 && !src_url_equal(img.src, img_src_value = /*$_thankYouImage*/ ctx[0])) {
    				attr(img, "src", img_src_value);
    			}
    		},
    		d(detaching) {
    			if (detaching) detach(img);
    		}
    	};
    }

    function create_fragment$2(ctx) {
    	let div;
    	let t0;
    	let p;
    	let t1;
    	let if_block = /*$_thankYouImage*/ ctx[0] && create_if_block$1(ctx);

    	return {
    		c() {
    			div = element("div");
    			if (if_block) if_block.c();
    			t0 = space();
    			p = element("p");
    			t1 = text(/*$_thankYouText*/ ctx[1]);
    			attr(div, "class", "ThankYouPage svelte-1qfhl3f");
    		},
    		m(target, anchor) {
    			insert(target, div, anchor);
    			if (if_block) if_block.m(div, null);
    			append(div, t0);
    			append(div, p);
    			append(p, t1);
    		},
    		p(ctx, [dirty]) {
    			if (/*$_thankYouImage*/ ctx[0]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$1(ctx);
    					if_block.c();
    					if_block.m(div, t0);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}

    			if (dirty & /*$_thankYouText*/ 2) set_data(t1, /*$_thankYouText*/ ctx[1]);
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div);
    			if (if_block) if_block.d();
    		}
    	};
    }

    function instance$2($$self, $$props, $$invalidate) {
    	let $_thankYouImage;
    	let $_thankYouText;
    	component_subscribe($$self, _thankYouImage, $$value => $$invalidate(0, $_thankYouImage = $$value));
    	component_subscribe($$self, _thankYouText, $$value => $$invalidate(1, $_thankYouText = $$value));
    	return [$_thankYouImage, $_thankYouText];
    }

    class ThankYouPage extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$2, create_fragment$2, safe_not_equal, {}, add_css$2);
    	}
    }

    /* src/components/Modal.svelte generated by Svelte v3.59.2 */

    function add_css$1(target) {
    	append_styles(target, "svelte-z360mx", ".Modal.svelte-z360mx{color:#222222;font-weight:300;position:fixed;background:#fff;box-shadow:0 0 8px rgba(0, 0, 0, 0.1490196078);z-index:1000;width:100%;top:0;right:0;height:100vh;height:100dvh;transition:right 0.3s;overflow-y:auto;display:flex;flex-direction:column}@media(min-width: 751px){.Modal.svelte-z360mx{width:480px;box-shadow:0 0 8px rgba(0, 0, 0, 0.1490196078)}}.Modal__header.svelte-z360mx{padding:20px 30px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #edece8;position:relative}.Modal__close.svelte-z360mx{min-width:44px;min-height:44px;position:absolute;top:0;bottom:0;right:20px}.Modal__close.svelte-z360mx:before,.Modal__close.svelte-z360mx:after{content:\"\";position:absolute;left:50%;top:50%;width:57%;height:1px;background:#222;transform:translate(-50%, -50%) rotate(-45deg)}.Modal__close.svelte-z360mx:after{transform:translate(-50%, -50%) rotate(45deg)}.Modal__title.svelte-z360mx{font-size:22px;line-height:22px}.Modal__body.svelte-z360mx{flex:1;overflow:hidden}.Modal.svelte-z360mx:not(.open){right:-100%}");
    }

    // (19:8) {:else }
    function create_else_block(ctx) {
    	let span;

    	return {
    		c() {
    			span = element("span");
    			span.textContent = "Order Swatches";
    			attr(span, "class", "Modal__title svelte-z360mx");
    		},
    		m(target, anchor) {
    			insert(target, span, anchor);
    		},
    		p: noop,
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(span);
    		}
    	};
    }

    // (17:8) {#if $_currentPage !== Page.Cart}
    function create_if_block_4(ctx) {
    	let navbutton;
    	let current;

    	navbutton = new NavButton({
    			props: {
    				secondary: true,
    				onClick: /*func*/ ctx[3],
    				$$slots: { default: [create_default_slot] },
    				$$scope: { ctx }
    			}
    		});

    	return {
    		c() {
    			create_component(navbutton.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(navbutton, target, anchor);
    			current = true;
    		},
    		p(ctx, dirty) {
    			const navbutton_changes = {};

    			if (dirty & /*$$scope*/ 16) {
    				navbutton_changes.$$scope = { dirty, ctx };
    			}

    			navbutton.$set(navbutton_changes);
    		},
    		i(local) {
    			if (current) return;
    			transition_in(navbutton.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(navbutton.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(navbutton, detaching);
    		}
    	};
    }

    // (18:12) <NavButton secondary={true} onClick={() => navTo(Page.Cart)}>
    function create_default_slot(ctx) {
    	let t;

    	return {
    		c() {
    			t = text("back to fabrics");
    		},
    		m(target, anchor) {
    			insert(target, t, anchor);
    		},
    		d(detaching) {
    			if (detaching) detach(t);
    		}
    	};
    }

    // (26:8) {#if $_currentPage === Page.Cart}
    function create_if_block_3(ctx) {
    	let cartpage;
    	let current;
    	cartpage = new CartPage({});

    	return {
    		c() {
    			create_component(cartpage.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(cartpage, target, anchor);
    			current = true;
    		},
    		i(local) {
    			if (current) return;
    			transition_in(cartpage.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(cartpage.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(cartpage, detaching);
    		}
    	};
    }

    // (29:8) {#if $_currentPage === Page.Filters}
    function create_if_block_2(ctx) {
    	let filterspage;
    	let current;
    	filterspage = new FiltersPage({});

    	return {
    		c() {
    			create_component(filterspage.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(filterspage, target, anchor);
    			current = true;
    		},
    		i(local) {
    			if (current) return;
    			transition_in(filterspage.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(filterspage.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(filterspage, detaching);
    		}
    	};
    }

    // (32:8) {#if $_currentPage === Page.Form}
    function create_if_block_1(ctx) {
    	let formpage;
    	let current;
    	formpage = new FormPage({});

    	return {
    		c() {
    			create_component(formpage.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(formpage, target, anchor);
    			current = true;
    		},
    		i(local) {
    			if (current) return;
    			transition_in(formpage.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(formpage.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(formpage, detaching);
    		}
    	};
    }

    // (35:8) {#if $_currentPage === Page.ThankYou}
    function create_if_block(ctx) {
    	let thankyoupage;
    	let current;
    	thankyoupage = new ThankYouPage({});

    	return {
    		c() {
    			create_component(thankyoupage.$$.fragment);
    		},
    		m(target, anchor) {
    			mount_component(thankyoupage, target, anchor);
    			current = true;
    		},
    		i(local) {
    			if (current) return;
    			transition_in(thankyoupage.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(thankyoupage.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			destroy_component(thankyoupage, detaching);
    		}
    	};
    }

    function create_fragment$1(ctx) {
    	let div2;
    	let div0;
    	let current_block_type_index;
    	let if_block0;
    	let t0;
    	let button;
    	let t1;
    	let div1;
    	let t2;
    	let t3;
    	let t4;
    	let current;
    	let mounted;
    	let dispose;
    	const if_block_creators = [create_if_block_4, create_else_block];
    	const if_blocks = [];

    	function select_block_type(ctx, dirty) {
    		if (/*$_currentPage*/ ctx[1] !== Page.Cart) return 0;
    		return 1;
    	}

    	current_block_type_index = select_block_type(ctx);
    	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    	let if_block1 = /*$_currentPage*/ ctx[1] === Page.Cart && create_if_block_3();
    	let if_block2 = /*$_currentPage*/ ctx[1] === Page.Filters && create_if_block_2();
    	let if_block3 = /*$_currentPage*/ ctx[1] === Page.Form && create_if_block_1();
    	let if_block4 = /*$_currentPage*/ ctx[1] === Page.ThankYou && create_if_block();

    	return {
    		c() {
    			div2 = element("div");
    			div0 = element("div");
    			if_block0.c();
    			t0 = space();
    			button = element("button");
    			t1 = space();
    			div1 = element("div");
    			if (if_block1) if_block1.c();
    			t2 = space();
    			if (if_block2) if_block2.c();
    			t3 = space();
    			if (if_block3) if_block3.c();
    			t4 = space();
    			if (if_block4) if_block4.c();
    			attr(button, "class", "Modal__close svelte-z360mx");
    			attr(div0, "class", "Modal__header svelte-z360mx");
    			attr(div1, "class", "Modal__body svelte-z360mx");
    			attr(div2, "class", "Modal svelte-z360mx");
    			toggle_class(div2, "open", /*$_isOpen*/ ctx[0]);
    		},
    		m(target, anchor) {
    			insert(target, div2, anchor);
    			append(div2, div0);
    			if_blocks[current_block_type_index].m(div0, null);
    			append(div0, t0);
    			append(div0, button);
    			append(div2, t1);
    			append(div2, div1);
    			if (if_block1) if_block1.m(div1, null);
    			append(div1, t2);
    			if (if_block2) if_block2.m(div1, null);
    			append(div1, t3);
    			if (if_block3) if_block3.m(div1, null);
    			append(div1, t4);
    			if (if_block4) if_block4.m(div1, null);
    			current = true;

    			if (!mounted) {
    				dispose = listen(button, "click", /*handleClose*/ ctx[2]);
    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			let previous_block_index = current_block_type_index;
    			current_block_type_index = select_block_type(ctx);

    			if (current_block_type_index === previous_block_index) {
    				if_blocks[current_block_type_index].p(ctx, dirty);
    			} else {
    				group_outros();

    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
    					if_blocks[previous_block_index] = null;
    				});

    				check_outros();
    				if_block0 = if_blocks[current_block_type_index];

    				if (!if_block0) {
    					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    					if_block0.c();
    				} else {
    					if_block0.p(ctx, dirty);
    				}

    				transition_in(if_block0, 1);
    				if_block0.m(div0, t0);
    			}

    			if (/*$_currentPage*/ ctx[1] === Page.Cart) {
    				if (if_block1) {
    					if (dirty & /*$_currentPage*/ 2) {
    						transition_in(if_block1, 1);
    					}
    				} else {
    					if_block1 = create_if_block_3();
    					if_block1.c();
    					transition_in(if_block1, 1);
    					if_block1.m(div1, t2);
    				}
    			} else if (if_block1) {
    				group_outros();

    				transition_out(if_block1, 1, 1, () => {
    					if_block1 = null;
    				});

    				check_outros();
    			}

    			if (/*$_currentPage*/ ctx[1] === Page.Filters) {
    				if (if_block2) {
    					if (dirty & /*$_currentPage*/ 2) {
    						transition_in(if_block2, 1);
    					}
    				} else {
    					if_block2 = create_if_block_2();
    					if_block2.c();
    					transition_in(if_block2, 1);
    					if_block2.m(div1, t3);
    				}
    			} else if (if_block2) {
    				group_outros();

    				transition_out(if_block2, 1, 1, () => {
    					if_block2 = null;
    				});

    				check_outros();
    			}

    			if (/*$_currentPage*/ ctx[1] === Page.Form) {
    				if (if_block3) {
    					if (dirty & /*$_currentPage*/ 2) {
    						transition_in(if_block3, 1);
    					}
    				} else {
    					if_block3 = create_if_block_1();
    					if_block3.c();
    					transition_in(if_block3, 1);
    					if_block3.m(div1, t4);
    				}
    			} else if (if_block3) {
    				group_outros();

    				transition_out(if_block3, 1, 1, () => {
    					if_block3 = null;
    				});

    				check_outros();
    			}

    			if (/*$_currentPage*/ ctx[1] === Page.ThankYou) {
    				if (if_block4) {
    					if (dirty & /*$_currentPage*/ 2) {
    						transition_in(if_block4, 1);
    					}
    				} else {
    					if_block4 = create_if_block();
    					if_block4.c();
    					transition_in(if_block4, 1);
    					if_block4.m(div1, null);
    				}
    			} else if (if_block4) {
    				group_outros();

    				transition_out(if_block4, 1, 1, () => {
    					if_block4 = null;
    				});

    				check_outros();
    			}

    			if (!current || dirty & /*$_isOpen*/ 1) {
    				toggle_class(div2, "open", /*$_isOpen*/ ctx[0]);
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(if_block0);
    			transition_in(if_block1);
    			transition_in(if_block2);
    			transition_in(if_block3);
    			transition_in(if_block4);
    			current = true;
    		},
    		o(local) {
    			transition_out(if_block0);
    			transition_out(if_block1);
    			transition_out(if_block2);
    			transition_out(if_block3);
    			transition_out(if_block4);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div2);
    			if_blocks[current_block_type_index].d();
    			if (if_block1) if_block1.d();
    			if (if_block2) if_block2.d();
    			if (if_block3) if_block3.d();
    			if (if_block4) if_block4.d();
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance$1($$self, $$props, $$invalidate) {
    	let $_isOpen;
    	let $_currentPage;
    	component_subscribe($$self, _isOpen, $$value => $$invalidate(0, $_isOpen = $$value));
    	component_subscribe($$self, _currentPage, $$value => $$invalidate(1, $_currentPage = $$value));

    	function handleClose() {
    		_isOpen.update(() => false);
    	}

    	const func = () => navTo(Page.Cart);
    	return [$_isOpen, $_currentPage, handleClose, func];
    }

    class Modal extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance$1, create_fragment$1, safe_not_equal, {}, add_css$1);
    	}
    }

    /* src/App.svelte generated by Svelte v3.59.2 */

    function add_css(target) {
    	append_styles(target, "svelte-b2bpx6", ".OrderSwatchesWrapper.svelte-b2bpx6{box-sizing:border-box}.OrderSwatchesWrapper.svelte-b2bpx6 *{box-sizing:border-box !important}.OrderSwatchesOverlay.svelte-b2bpx6{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(34, 34, 34, 0.2509803922);z-index:999;display:block !important;transition:opacity 0.3s}.OrderSwatchesOverlay.svelte-b2bpx6:not(.open){pointer-events:none;opacity:0}");
    }

    function create_fragment(ctx) {
    	let div1;
    	let div0;
    	let t;
    	let modal;
    	let current;
    	let mounted;
    	let dispose;
    	modal = new Modal({});

    	return {
    		c() {
    			div1 = element("div");
    			div0 = element("div");
    			t = space();
    			create_component(modal.$$.fragment);
    			attr(div0, "class", "OrderSwatchesOverlay svelte-b2bpx6");
    			toggle_class(div0, "open", /*$_isOpen*/ ctx[0]);
    			attr(div1, "class", "OrderSwatchesWrapper svelte-b2bpx6");
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, div0);
    			append(div1, t);
    			mount_component(modal, div1, null);
    			current = true;

    			if (!mounted) {
    				dispose = listen(div0, "click", /*handleOverlayClick*/ ctx[1]);
    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			if (!current || dirty & /*$_isOpen*/ 1) {
    				toggle_class(div0, "open", /*$_isOpen*/ ctx[0]);
    			}
    		},
    		i(local) {
    			if (current) return;
    			transition_in(modal.$$.fragment, local);
    			current = true;
    		},
    		o(local) {
    			transition_out(modal.$$.fragment, local);
    			current = false;
    		},
    		d(detaching) {
    			if (detaching) detach(div1);
    			destroy_component(modal);
    			mounted = false;
    			dispose();
    		}
    	};
    }

    function instance($$self, $$props, $$invalidate) {
    	let $_isOpen;
    	component_subscribe($$self, _isOpen, $$value => $$invalidate(0, $_isOpen = $$value));

    	function handleOverlayClick() {
    		_isOpen.update(() => false);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*$_isOpen*/ 1) {
    			{
    				$_isOpen
    				? document.body.classList.add('disable-scroll')
    				: document.body.classList.remove('disable-scroll');
    			}
    		}
    	};

    	return [$_isOpen, handleOverlayClick];
    }

    class App extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance, create_fragment, safe_not_equal, {}, add_css);
    	}
    }

    const renderWidget = (target) => {
        return new App({
            target
        });
    };

    const createRenderTargets = () => {
        const target = document.createElement('div');
        document.body.appendChild(target);
        return target;
    };

    function timeDifference(date1, date2) {
        const differenceInSeconds = Math.abs((date1 - date2) / 1000);
        return `${differenceInSeconds} sec`;
    }

    function prepareColorFilters(variants) {
        const colors = {};
        for (const variant of variants) {
            const colorTitle = variant.color.trim();
            if (!colorTitle)
                continue;
            if (!(colorTitle in colors)) {
                colors[colorTitle] = {
                    quantity: 1,
                    hex: variant.colorHex
                };
            }
            else {
                colors[colorTitle].quantity = colors[colorTitle].quantity + 1;
            }
        }
        return colors;
    }

    function prepareFeatureFilters(variants) {
        const features = {};
        for (const variant of variants) {
            for (const feature of variant.features) {
                const featureTitle = feature.trim();
                if (!featureTitle)
                    continue;
                if (!(featureTitle in features)) {
                    features[featureTitle] = {
                        quantity: 1
                    };
                }
                else {
                    features[featureTitle].quantity = features[featureTitle].quantity + 1;
                }
            }
        }
        return features;
    }

    function prepareFilters(variants, type) {
        var _a;
        const filters = {};
        for (const variant of variants) {
            const title = (_a = variant[type]) === null || _a === void 0 ? void 0 : _a.trim();
            if (!title)
                continue;
            if (!(title in filters)) {
                filters[title] = {
                    quantity: 1
                };
            }
            else {
                filters[title].quantity = filters[title].quantity + 1;
            }
        }
        return filters;
    }

    (async () => {
        var _a, _b, _c, _d, _e;
        const startTime = Date.now();
        const scriptJson = (_c = (_b = (_a = document.querySelector('script#SwatchesJson')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.replace(/,\s*([\]}])/g, '$1');
        if (!scriptJson)
            return;
        const json = JSON.parse(scriptJson);
        if (!Array.isArray(json.variants) || !((_d = json.variants) === null || _d === void 0 ? void 0 : _d.length))
            return;
        _formUrl.set(json.formCarryUrl);
        _thankYouText.set(json.thankYouText);
        _thankYouImage.set(json.thankYouImage);
        _variants.set(json.variants);
        _filteredVariants.set(json.variants);
        console.log('VARIANTS', json);
        _colorFilters.set(prepareColorFilters(json.variants));
        _featureFilters.set(prepareFeatureFilters(json.variants));
        _typeFilters.set(prepareFilters(json.variants, 'type'));
        _patternFilters.set(prepareFilters(json.variants, 'pattern'));
        const target = createRenderTargets();
        renderWidget(target);
        (_e = document.querySelector('.js-swatches-trigger')) === null || _e === void 0 ? void 0 : _e.addEventListener('click', () => {
            _currentPage.update(() => Page.Cart);
            _isOpen.update(() => true);
        });
        const endTime = Date.now();
        console.log('Order Swatcher render speed:', timeDifference(startTime, endTime));
    })();

})();
//# sourceMappingURL=order-swatches.bundle.js.map
